<template>
  <div class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-12">
          <h1 class="m-0">
            <button style="margin-right: 25px; font-size: 15px" onclick="history.back()" class="btn btn-primary btn-lg">Voltar</button>
            Detalhes do cadastro

            <a href="/admin/fluxo_de_cadastros?filter=aguardando_liberacao" class="btn btn-primary btn-lg" style="font-size: 15px; margin-left: 15px">
              Fluxo cadastros (Aguardando liberação)
            </a>
          </h1>
        </div>
        <!-- /.col -->
        <div class="col-sm-12">
          <ol class="breadcrumb float-sm-left">
            <li class="breadcrumb-item"><a href="/">Home</a></li>
            <li class="breadcrumb-item"><a href="/admin/cadastros/todos">Todos os cadastros</a></li>
            <li class="breadcrumb-item">Detalhes</li>
            <li class="breadcrumb-item" v-if="user.id">{{ user.id }}</li>
          </ol>
        </div>
        <!-- /.col -->
      </div>
      <!-- /.row -->
    </div>
    <!-- /.container-fluid -->
  </div>

  <div v-if="user_profile">
    <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />
    <br />
    <div style="text-align: center"></div>
    <h3 style="text-transform: uppercase" v-if="user">
      <i class="fa-solid fa-circle" style="margin-right: 7px" :style="getStyleOnline(user)"></i>
      <a style="margin-right: 15px">{{ user.apelido }}</a>

      <strong style="color: rgb(255, 217, 0)" v-if="user.status == 'pendente'">{{ user.status }}</strong>
      <strong style="color: #007d41" v-else-if="user.status == 'liberado'">{{ user.status }}</strong>
      <strong style="color: red" v-else-if="user.status == 'bloqueado'">{{ user.status }}</strong>
      <strong v-else="user.status == 'liberado'">{{ user.status }}</strong>

      <span
        class="right badge"
        style="font-size: 12px; margin-left: 3px; background-color: #9c362d; color: white"
        v-if="user_profile.telefone_celular_verificado == 0"
      >
        SMS NÃO VALIDADO
      </span>
      <span class="right badge" style="font-size: 12px; margin-left: 3px; background-color: #c24236; color: white" v-if="!user.email_verified_at">
        E-MAIL NÃO VALIDADO
      </span>

      <button
        id="navbarDropdown"
        class="btn btn-primary btn-sm"
        href="#"
        role="button"
        data-bs-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        v-pre
        style="margin-left: 15px"
      >
        Ações
        <i class="fa-solid fa-clock" style="margin-left: 5px"></i>
      </button>

      <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right" aria-labelledby="navbarDropdown" ref="menu">
        <div class="dropdown-divider"></div>
        <a class="dropdown-item" @click="validarUpdateStatus('liberar', true)">Liberar</a>
        <div class="dropdown-divider"></div>
        <a class="dropdown-item" @click="validarUpdateStatus('bloquear', true)">Bloquear</a>

        <div class="dropdown-divider"></div>
        <a class="dropdown-item" @click="validarUpdateStatus('liberar')">Liberar sem notificar</a>
        <div class="dropdown-divider"></div>
        <a class="dropdown-item" @click="validarUpdateStatus('bloquear')">Bloquear sem notificar</a>
      </div>
    </h3>
    <br />

    <p style="color: gray; font-size: 14px; margin-top: 2px">
      {{ user.email }} (Último login {{ formatDateTime(user.last_login) }}) (Data de cadastro: {{ formatDateTime(user_profile.created_at) }}) (IP de
      cadastro: {{ user_profile.cadastro_ip }})
      <span
        @click="cadastro_selecionado = user_profile"
        data-toggle="modal"
        data-target="#visualizar-ips"
        class="right badge badge-danger"
        style="margin-left: 15px; background-color: blue; cursor: pointer"
        v-if="user_profile.ips && user_profile.ips.length > 0"
      >
        Existe
      </span>
    </p>

    <!--
    <div style="margin-top: -3%;">
       
        <button tooltip="Dados" type="button" class="iconDiv btn btn-primary btn-sm" style="margin-left: 5px;">
            <div class="iconSVG">
                <i class="fa-solid fa-user"></i>
            </div>
        </button>
        
        <button class="iconDiv btn btn-primary btn-sm" tooltip="Editar" tabindex="0" data-toggle="modal"
            data-target="#editar-cadastro-modal" type="button" @click="editar_cadastro = true;">
            <div class="iconSVG">
                <i class="fa-solid fa-pen"></i>
            </div>
        </button>

        <button tooltip="Notificações" id="notificacao_btn" data-toggle="modal" @click="conteudo_notificacao = ''"
            data-target="#notificacao-modal" type="button" class="iconDiv btn btn-primary btn-sm" style="margin-left: 5px;">
            <div class="iconSVG">
                <i class="fa-solid fa-envelope"></i>
            </div>
        </button>

        <button tooltip="Pendências" data-toggle="modal" data-target="#pendencias-modal" @click="conteudo_pendencia = ''"
            type="button" class="iconDiv btn btn-primary btn-sm" style="margin-left: 5px;">
            <i class="fa-solid fa-circle-exclamation"></i>
            <span class="right badge badge-danger" style="float: right;">
                <a style="color: white" v-if="pendencias.length">{{ pendencias.length }}</a>
                <a style="color: white" v-else>0</a>
            </span>
        </button>

        <button tooltip="Ações" id="navbarDropdown" class="iconDiv btn btn-primary btn-sm" href="#" role="button"
            data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-pre style="margin-left: 5px;">
            <div class="iconSVG">
                <i class="fa-solid fa-clock"></i>
            </div>
        </button>

        <button tooltip="Anotações" data-toggle="modal" @click="anotacoes = user.observacoes" data-target="#anotacoes-modal"
            type="button" class="iconDiv btn btn-primary btn-sm" style="margin-left: 5px;">
            <i class="fa-solid fa-comment"></i>

            <span v-if="user.observacoes && user.observacoes != ''" class="right badge badge-danger"
                style="float: right; background-color:#5b5bd6">
                <a>!</a>
            </span>
        </button>

        <button tooltip="Documentos" data-toggle="modal" @click="buscarDocumentos" data-target="#documentos-modal"
            type="button" class="iconDiv btn btn-primary btn-sm" style="margin-left: 5px;">
            <div class="iconSVG">
                <i class="fa-solid fa-file"></i>
            </div>
        </button>

        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right" aria-labelledby="navbarDropdown" ref="menu">

            <div class="dropdown-divider"></div>
            <a data-toggle="modal" data-target="#notificacao-modal" class="dropdown-item"
                @click="acao_necessaria = 'liberar'">
                Liberar
            </a>
            <div class="dropdown-divider"></div>
            <a data-toggle="modal" data-target="#notificacao-modal" class="dropdown-item"
                @click="acao_necessaria = 'bloquear'">
                Bloquear
            </a>

            <div class="dropdown-divider"></div>
            <a class="dropdown-item" @click="updateStatus('liberar')">
                Liberar sem notificar
            </a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" @click="updateStatus('bloquear')">
                Bloquear sem notificar
            </a>
        </div>
    </div>
     -->

    <!-- ANOTAÇÕES INTERNAS -->
    <div class="card card-primary">
      <div class="card-header">
        <h5 class="card-title" id="accordion">
          <i class="fa-solid fa-comment"></i>
          &nbsp; Anotações internas
          <button
            style="margin-left: 15px"
            data-toggle="modal"
            data-target="#anotacoes-modal"
            type=" button"
            class="btn btn-primary btn-sm"
            @click="anotacoes = user.observacoes"
          >
            Editar
          </button>

          <button style="margin-left: 15px" type=" button" class="btn btn-danger btn-sm" @click="limparAnotacoes()">Limpar</button>

          <span v-if="user.observacoes_updated_at" style="margin-left: 15px">{{ formatDateTime(user.observacoes_updated_at) }}</span>
        </h5>
      </div>
      <div class="card-body table-responsive p-2">
        <div class="col-sm-12">
          <div class="form-group">
            <textarea
              readonly="true"
              id="justificativa"
              name="justificativa"
              rows="4"
              cols="50"
              style="width: 100%; margin-top: 5px"
              v-model="user.observacoes"
            ></textarea>
          </div>
        </div>
        <div class="col-sm-12">
          <div class="form-group"></div>
        </div>
      </div>
    </div>

    <!-- PENDÊNCIAS -->
    <div class="card card-primary">
      <div class="card-header">
        <h5 class="card-title" id="accordion">
          <i class="fa-solid fa-circle-exclamation"></i>
          &nbsp; Pendências
          <!--
          <button
            class="btn btn-primary btn-sm"
            style="margin-left: 15px"
            data-toggle="modal"
            data-target="#pendencias-modal"
            @click="conteudo_pendencia = ''"
            type="button"
          >
            Cadastrar pendência
            <i class="fa fa-plus" style="margin-left: 5px"></i>
          </button>
          -->
          <button
            class="btn btn-primary btn-sm"
            style="margin-left: 15px"
            data-toggle="modal"
            data-target="#pendencia-e-email-modal"
            @click="buscarEmailPendencia()"
            type="button"
          >
            Cadastrar pendência e enviar e-mail
            <i class="fa fa-plus" style="margin-left: 5px"></i>
          </button>
        </h5>
      </div>

      <div class="card-body table-responsive p-0">
        <table class="table table-hover" v-if="pendencias.length">
          <thead>
            <tr>
              <th>Criação</th>
              <th style="width: 82%">Conteúdo</th>
              <th>Resolvida</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="pendencia in pendencias" :key="pendencia">
              <td>{{ formatDateTime(pendencia.created_at) }}</td>
              <td data-label="Conteúdo">{{ getOnlyText(pendencia.conteudo) }}</td>

              <td>
                <span v-if="pendencia.resolvido == 0">Não</span>
                <span v-else="pendencia.resolvido == 1">Sim</span>
              </td>

              <td v-if="pendencia.resolvido == 0">
                <button style="width: 100%" @click="confirmarResolver(pendencia)" type="button" class="btn btn-success btn-sm">
                  Resolver
                  <i class="fa fa-check" style="margin-left: 5px"></i>
                </button>
                <button
                  style="margin-top: 3px; width: 100%; background-color: #d43f3a; border-color: #d43f3a"
                  @click="confirmarDelete(pendencia, 'pendencia')"
                  type="button"
                  class="btn btn-danger btn-sm"
                >
                  Deletar
                  <i class="fa fa-trash" style="margin-left: 5px"></i>
                </button>
              </td>
              <td v-else>
                <button
                  style="margin-top: 3px; width: 100%; background-color: #d43f3a; border-color: #d43f3a"
                  @click="confirmarDelete(pendencia, 'pendencia')"
                  type="button"
                  class="btn btn-danger btn-sm"
                >
                  Deletar
                  <i class="fa fa-trash" style="margin-left: 5px"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <tr v-else>
          <label style="margin-left: 15px; margin-top: 5px">Sem pendências...</label>
          <br />
        </tr>
      </div>
    </div>

    <!-- NOTIFICAÇÕES -->
    <div class="card card-primary">
      <div class="card-header">
        <h5 class="card-title" id="accordion">
          <i class="fa-solid fa-envelope"></i>
          &nbsp; Notificações
          <button
            class="btn btn-primary btn-sm"
            style="margin-left: 15px"
            id="notificacao_btn"
            data-toggle="modal"
            @click="buscarEmailNotificacao()"
            data-target="#notificacao-modal"
            type="button"
          >
            Cadastrar notificação
            <i class="fa fa-plus" style="margin-left: 5px"></i>
          </button>
        </h5>
      </div>

      <div class="card-body table-responsive p-0">
        <table class="table table-hover text-nowrap" v-if="notificacoes.length">
          <thead>
            <tr>
              <th style="width: 85%">Conteúdo</th>
              <th>Data criação</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="notificacao in notificacoes" :key="notificacao">
              <td data-label="Conteúdo">{{ notificacao.conteudo_text }}</td>

              <td data-label="Data criação">{{ formatDateTime(notificacao.created_at) }}</td>

              <td>
                <button
                  style="margin-left: 15px; background-color: #d43f3a; border-color: #d43f3a"
                  @click="confirmarDelete(notificacao, 'notificacao')"
                  type="button"
                  class="btn btn-danger btn-sm"
                >
                  Deletar
                  <i class="fa fa-trash" style="margin-left: 5px"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <tr v-else>
          <label style="margin-left: 15px; margin-top: 5px">Sem notificações...</label>
          <br />
        </tr>
      </div>
    </div>

    <!-- DADOS CADASTRAIS -->
    <div class="card">
      <div class="card-header">
        <h5 class="card-title" id="accordion">
          <i class="fas fa-user"></i>
          &nbsp; Dados cadastrais
          <button
            class="btn btn-primary btn-sm"
            style="margin-left: 15px"
            data-toggle="modal"
            data-target="#editar-cadastro-modal"
            type="button"
            @click="editar_cadastro = true"
          >
            Editar
            <i class="fa fa-pen" style="margin-left: 5px"></i>
          </button>

          <span
            class="right badge badge-danger"
            style="margin-left: 15px; background-color: blue"
            v-if="user_profile.cadastro_tipo == 'pf' && user_profile.magistrado == 1"
          >
            PF-MAGISTRADO
          </span>
          <span class="right badge badge-danger" style="margin-left: 15px; background-color: #301904" v-else-if="user_profile.cadastro_tipo == 'pj'">
            PJ
          </span>
          <span class="right badge badge-danger" style="margin-left: 15px; background-color: blue" v-else-if="user_profile.cadastro_tipo == 'pf'">
            PF
          </span>
        </h5>
      </div>
      <div class="card-body">
        <div class="row" v-if="user_profile.cadastro_tipo == 'pj'">
          <div class="col-sm-12">
            <br />
            <h6>
              <i class="fa-solid fa-building" style="margin-right: 7px"></i>
              DADOS DA EMPRESA
            </h6>
            <hr />
          </div>

          <div class="col-sm-12">
            <div class="form-group">
              <label for="nome">Razão social</label>
              <input readonly="true" class="form-control" id="id" v-model="user_profile.pj_razao_social" style="text-transform: uppercase" />
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label for="nome">Nome fantasia</label>
              <input readonly="true" class="form-control" id="id" v-model="user_profile.pj_nome_fantasia" style="text-transform: uppercase" />
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label for="nome">CNPJ</label>
              <InputMask id="basic" readonly="true" class="form-control" v-model="user_profile.pj_cnpj" mask="99.999.999/9999-99" />
            </div>
          </div>

          <div class="col-sm-2">
            <div class="form-group">
              <label for="nome">CEP</label>
              <input readonly="true" class="form-control" id="id" v-model="user_profile.pj_endereco_cep" style="text-transform: uppercase" />
            </div>
          </div>

          <div class="col-sm-4">
            <div class="form-group">
              <label for="nome">Endereço</label>
              <input readonly="true" class="form-control" id="id" v-model="user_profile.pj_endereco" style="text-transform: uppercase" />
            </div>
          </div>

          <div class="col-sm-3">
            <div class="form-group">
              <label for="nome">Número</label>
              <input readonly="true" class="form-control" id="id" v-model="user_profile.pj_endereco_num" style="text-transform: uppercase" />
            </div>
          </div>

          <div class="col-sm-3">
            <div class="form-group">
              <label for="nome">Bairro</label>
              <input readonly="true" class="form-control" id="id" v-model="user_profile.pj_endereco_bairro" style="text-transform: uppercase" />
            </div>
          </div>

          <div class="col-sm-3">
            <div class="form-group">
              <label for="nome">Complemento</label>
              <input readonly="true" class="form-control" id="id" v-model="user_profile.pj_endereco_complemento" style="text-transform: uppercase" />
            </div>
          </div>

          <div class="col-sm-3">
            <div class="form-group">
              <label for="endereco_cidade">Cidade</label>

              <select
                disabled="true"
                class="custom-select rounded-0"
                id="endereco_cidade"
                v-model="user_profile.pj_cidade_id"
                style="text-transform: uppercase"
              >
                <option v-for="cidade in my_cidades_pj" :key="cidade.id" :value="cidade.id">
                  {{ cidade.nome }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-sm-3">
            <div class="form-group">
              <label for="endereco_estado">UF</label>

              <select
                disabled="true"
                class="custom-select rounded-0"
                id="endereco_estado"
                v-model="user_profile.pj_estado_id"
                style="text-transform: uppercase"
              >
                <option v-for="estado in estados" :key="estado.id" :value="estado.id">
                  {{ estado.nome }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12" v-if="user_profile.cadastro_tipo == 'pj'">
            <br />
            <h6>
              <i class="fa-solid fa-user" style="margin-right: 7px"></i>
              DADOS DO REPRESENTANTE LEGAL
            </h6>
            <hr />
          </div>

          <div class="col-sm-6">
            <div class="form-group">
              <label for="nome">Apelido</label>
              <input readonly="true" style="text-transform: uppercase" class="form-control" id="id" v-model="user.apelido" />
            </div>
          </div>

          <div class="col-sm-6">
            <div class="form-group">
              <label for="nome">Magistrado</label>
              <select class="custom-select rounded-0" disabled v-model="user_profile.magistrado" style="text-transform: uppercase">
                <option :value="0">Não</option>
                <option :value="1">Sim</option>
              </select>
            </div>
          </div>

          <div class="col-sm-3">
            <div class="form-group">
              <label for="nome">Nome</label>
              <input readonly="true" style="text-transform: uppercase" class="form-control" id="id" v-model="user_profile.nome_completo" />
            </div>
          </div>
          <div class="col-sm-2">
            <div class="form-group">
              <label for="nome">
                CPF
                <span
                  @click="cadastro_selecionado = user_profile"
                  data-toggle="modal"
                  data-target="#visualizar-cpfs"
                  class="right badge badge-danger"
                  style="margin-left: 15px; background-color: blue; cursor: pointer"
                  v-if="user_profile.cpfs && user_profile.cpfs.length > 0"
                >
                  Existe
                </span>
              </label>
              <input readonly="true" class="form-control" id="id" :value="formatarCPF(user_profile.cpf)" />
            </div>
          </div>
          <div class="col-sm-2">
            <div class="form-group">
              <label for="nome">RG</label>
              <input style="text-transform: uppercase" readonly="true" class="form-control" id="id" v-model="user_profile.rg" />
            </div>
          </div>
          <div class="col-sm-3">
            <div class="form-group">
              <label for="nome">Orgão Exp</label>

              <input style="text-transform: uppercase" readonly="true" class="form-control" id="id" v-model="user_profile.rg_orgao_exp" />
            </div>
          </div>
          <div class="col-sm-2">
            <div class="form-group">
              <label for="nome">Data emissão</label>
              <input readonly="true" class="form-control" id="id" :value="formatDate(user_profile.rg_data_emissao)" />
            </div>
          </div>

          <div class="col-sm-4">
            <div class="form-group">
              <label for="nome">Nascimento</label>
              <input readonly="true" class="form-control" id="id" :value="formatDate(user_profile.data_nascimento)" />
            </div>
          </div>

          <div class="col-sm-4">
            <div class="form-group">
              <label for="nome">Nacionalidade</label>
              <input readonly="true" class="form-control" id="id" v-model="user_profile.nacionalidade" style="text-transform: uppercase" />
            </div>
          </div>

          <div class="col-sm-4">
            <div class="form-group">
              <label for="nome">Naturalidade</label>
              <input readonly="true" class="form-control" id="id" v-model="user_profile.naturalidade" style="text-transform: uppercase" />
            </div>
          </div>

          <div class="col-sm-4">
            <div class="form-group">
              <label for="nome">Filiação completa</label>
              <input readonly="true" class="form-control" id="id" v-model="user_profile.filiacao" style="text-transform: uppercase" />
            </div>
          </div>

          <div class="col-sm-4">
            <div class="form-group">
              <label for="sexo">Sexo</label>

              <select disabled="true" class="custom-select rounded-0" id="sexo" v-model="user_profile.sexo">
                <option value="feminino">FEMININO</option>
                <option value="masculino">MASCULINO</option>
              </select>
            </div>
          </div>

          <div class="col-sm-4">
            <div class="form-group">
              <label for="estado_civil">Estado civil</label>

              <select
                disabled="true"
                class="custom-select rounded-0"
                id="estado_civil"
                v-model="user_profile.estado_civil"
                style="text-transform: uppercase"
              >
                <option value="casado">Casado</option>
                <option value="divorciado">Divorciado</option>
                <option value="separado_judicialmente">Separado judicialmente</option>
                <option value="solteiro">Solteiro</option>
                <option value="solteiro_com_uniao_estavel">Solteiro com união estável</option>
                <option value="solteiro_sem_uniao_estavel">Solteiro sem união estável</option>
                <option value="uniao_estavel">União estável</option>
                <option value="viuvo">Viuvo</option>
              </select>
            </div>
          </div>

          <div class="col-sm-2">
            <div class="form-group">
              <label for="nome">CEP</label>
              <input readonly="true" class="form-control" id="id" v-model="user_profile.endereco_cep" />
            </div>
          </div>

          <div class="col-sm-4">
            <div class="form-group">
              <label for="nome">Endereço</label>
              <input readonly="true" class="form-control" id="id" v-model="user_profile.endereco" style="text-transform: uppercase" />
            </div>
          </div>

          <div class="col-sm-3">
            <div class="form-group">
              <label for="nome">Número</label>
              <input readonly="true" class="form-control" id="id" v-model="user_profile.endereco_num" style="text-transform: uppercase" />
            </div>
          </div>

          <div class="col-sm-3">
            <div class="form-group">
              <label for="nome">Bairro</label>
              <input readonly="true" class="form-control" id="id" v-model="user_profile.endereco_bairro" style="text-transform: uppercase" />
            </div>
          </div>

          <div class="col-sm-3">
            <div class="form-group">
              <label for="nome">Complemento</label>
              <input readonly="true" class="form-control" id="id" v-model="user_profile.endereco_complemento" style="text-transform: uppercase" />
            </div>
          </div>

          <div class="col-sm-3">
            <div class="form-group">
              <label for="endereco_cidade">Cidade</label>

              <select
                disabled="true"
                class="custom-select rounded-0"
                id="endereco_cidade"
                v-model="user_profile.cidade_id"
                style="text-transform: uppercase"
              >
                <option v-for="cidade in my_cidades" :key="cidade.id" :value="cidade.id">
                  {{ cidade.nome }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-sm-3">
            <div class="form-group">
              <label for="endereco_estado">UF</label>

              <select
                disabled="true"
                class="custom-select rounded-0"
                id="endereco_estado"
                v-model="user_profile.estado_id"
                style="text-transform: uppercase"
              >
                <option v-for="estado in estados" :key="estado.id" :value="estado.id">
                  {{ estado.nome }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-sm-3">
            <div class="form-group">
              <label for="nome">Fone</label>
              <input readonly="true" class="form-control" id="id" v-model="user_profile.telefone_fixo" />
            </div>
          </div>

          <div class="col-sm-3">
            <div class="form-group">
              <label for="nome">
                Celular

                <span
                  @click="cadastro_selecionado = user_profile"
                  data-toggle="modal"
                  data-target="#visualizar-celulares"
                  class="right badge badge-danger"
                  style="margin-left: 15px; background-color: blue; cursor: pointer"
                  v-if="user_profile.celulares && user_profile.celulares.length > 0"
                >
                  Existe
                </span>

                <span style="margin-left: 45px; font-size: 13px; color: black; font-weight: 500" v-if="user_profile.telefone_celular_verificado == 0">
                  Código:
                  <span>{{ user_profile.telefone_celular_verificacao_code }}</span>
                </span>
              </label>
              <label :class="user_profile.telefone_celular_verificado === 1 ? 'form-control green' : 'form-control'">
                {{ user_profile.telefone_celular }}
                <i v-if="user_profile.telefone_celular_verificado === 1" class="fa-solid fa-check" style="margin-left: 7px"></i>
              </label>
            </div>
          </div>

          <div class="col-sm-4">
            <div class="form-group">
              <label for="nome">Profissão</label>
              <input readonly="true" class="form-control" id="id" v-model="user_profile.profissao" />
            </div>
          </div>

          <div class="col-sm-4">
            <div class="form-group">
              <label for="nome">E-mail</label>
              <input readonly="true" class="form-control" id="id" v-model="user.email" />
            </div>
          </div>

          <div
            class="row p-2"
            v-if="
              user_profile.estado_civil == 'casado' ||
              user_profile.estado_civil == 'uniao_estavel' ||
              user_profile.estado_civil == 'solteiro_com_uniao_estavel'
            "
          >
            <div class="col-sm-12">
              <br />
              <h6>
                <i class="fa-solid fa-ring" style="margin-right: 7px"></i>
                DADOS DO CÔNJUGE
              </h6>
              <hr />
            </div>

            <div class="col-sm-12">
              <div class="form-group">
                <label for="regime_casamento">Regime do casamento/União:</label>
                <select
                  disabled="true"
                  class="custom-select rounded-0"
                  id="regime_casamento"
                  v-model="user_profile.regime_casamento"
                  style="text-transform: uppercase"
                >
                  <option value="cpb">Comunhão parcial de bens</option>
                  <option value="cub">Comunhão universal de bens</option>
                  <option value="outros">Outros</option>
                  <option value="pfa">Participação final nos aquestos</option>
                  <option value="seb">Separação de bens</option>
                </select>
              </div>
            </div>
          </div>

          <div
            class="row p-2"
            v-if="
              (user_profile.estado_civil == 'casado' ||
                user_profile.estado_civil == 'uniao_estavel' ||
                user_profile.estado_civil == 'solteiro_com_uniao_estavel') &&
              user_profile.cadastro_tipo == 'pf'
            "
          >
            <div class="col-sm-3">
              <div class="form-group">
                <label for="nome">Nome</label>
                <input readonly="true" class="form-control" id="id" v-model="user_profile.conjuge_nome_completo" />
              </div>
            </div>
            <div class="col-sm-2">
              <div class="form-group">
                <label for="nome">CPF</label>
                <input readonly="true" class="form-control" id="id" :value="formatarCPF(user_profile.conjuge_cpf)" />
              </div>
            </div>
            <div class="col-sm-2">
              <div class="form-group">
                <label for="nome">RG</label>
                <input readonly="true" class="form-control" id="id" v-model="user_profile.conjuge_rg" />
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group">
                <label for="nome">Orgão Exp</label>

                <input style="text-transform: uppercase" readonly="true" class="form-control" id="id" v-model="user_profile.conjuge_rg_orgao_exp" />
              </div>
            </div>
            <div class="col-sm-2">
              <div class="form-group">
                <label for="nome">Data emissão</label>
                <input readonly="true" class="form-control" id="id" :value="formatDate(user_profile.conjuge_rg_data_emissao)" />
              </div>
            </div>

            <div class="col-sm-4">
              <div class="form-group">
                <label for="nome">Nascimento</label>
                <input readonly="true" class="form-control" id="id" :value="formatDate(user_profile.conjuge_data_nascimento)" />
              </div>
            </div>

            <div class="col-sm-4">
              <div class="form-group">
                <label for="nome">Nacionalidade</label>
                <input readonly="true" class="form-control" id="id" v-model="user_profile.conjuge_nacionalidade" />
              </div>
            </div>

            <div class="col-sm-4">
              <div class="form-group">
                <label for="nome">Naturalidade</label>
                <input readonly="true" class="form-control" id="id" v-model="user_profile.conjuge_naturalidade" />
              </div>
            </div>

            <div class="col-sm-4">
              <div class="form-group">
                <label for="nome">Profissão</label>
                <input readonly="true" class="form-control" id="id" v-model="user_profile.conjuge_profissao" />
              </div>
            </div>

            <div class="col-sm-4">
              <div class="form-group">
                <label for="nome">Filiação completa</label>
                <input readonly="true" class="form-control" id="id" v-model="user_profile.conjuge_filiacao" />
              </div>
            </div>

            <div class="col-sm-4">
              <div class="form-group">
                <label for="sexo">Sexo</label>

                <select disabled="true" class="custom-select rounded-0" id="sexo" v-model="user_profile.conjuge_sexo">
                  <option value="feminino">FEMININO</option>
                  <option value="masculino">MASCULINO</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL CELULARES -->
    <div
      class="modal fade"
      id="visualizar-celulares"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="margin-top: 30px"
    >
      <form @submit.prevent>
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
              <h4>Ocorrências</h4>
              <br />
              <div class="card card-primary">
                <div class="card-body">
                  <table class="table table-hover text-nowrap">
                    <thead>
                      <tr>
                        <th>Seq</th>
                        <th>Apelido</th>
                        <th>Nome</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(usuario_online, index) in cadastro_selecionado.celulares" :key="usuario_online">
                        <td>{{ index + 1 }}</td>
                        <td>
                          <a :href="'/admin/cadastros/detalhes/' + usuario_online.user_id">{{ usuario_online.apelido }}</a>
                        </td>

                        <td>
                          <a :href="'/admin/cadastros/detalhes/' + usuario_online.user_id">{{ usuario_online.nome_completo }}</a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="card-footer">
                  <button data-dismiss="modal" aria-hidden="true" class="btn btn-danger">Fechar</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <!-- MODAL CPFS -->
    <div
      class="modal fade"
      id="visualizar-cpfs"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="margin-top: 30px"
    >
      <form @submit.prevent>
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
              <h4>Ocorrências</h4>
              <br />
              <div class="card card-primary">
                <div class="card-body">
                  <table class="table table-hover text-nowrap">
                    <thead>
                      <tr>
                        <th>Seq</th>
                        <th>Apelido</th>
                        <th>Nome</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(usuario_online, index) in cadastro_selecionado.cpfs" :key="usuario_online">
                        <td>{{ index + 1 }}</td>
                        <td>
                          <a :href="'/admin/cadastros/detalhes/' + usuario_online.user_id">{{ usuario_online.apelido }}</a>
                        </td>

                        <td>
                          <a :href="'/admin/cadastros/detalhes/' + usuario_online.user_id">{{ usuario_online.nome_completo }}</a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="card-footer">
                  <button data-dismiss="modal" aria-hidden="true" class="btn btn-danger">Fechar</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <!-- MODAL IPS -->
    <div
      class="modal fade"
      id="visualizar-ips"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="margin-top: 30px"
    >
      <form @submit.prevent>
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
              <h4>Ocorrências</h4>
              <br />
              <div class="card card-primary">
                <div class="card-body">
                  <table class="table table-hover text-nowrap">
                    <thead>
                      <tr>
                        <th>Seq</th>
                        <th>Apelido</th>
                        <th>Nome</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(usuario_online, index) in cadastro_selecionado.ips" :key="usuario_online">
                        <td>{{ index + 1 }}</td>
                        <td>
                          <a :href="'/admin/cadastros/detalhes/' + usuario_online.user_id">{{ usuario_online.apelido }}</a>
                        </td>

                        <td>
                          <a :href="'/admin/cadastros/detalhes/' + usuario_online.user_id">{{ usuario_online.nome_completo }}</a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="card-footer">
                  <button data-dismiss="modal" aria-hidden="true" class="btn btn-danger">Fechar</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <!-- DOCUMENTOS -->
    <div class="card card-primary">
      <div class="card-header">
        <h5 class="card-title" id="accordion">
          <i class="fa-solid fa-file"></i>
          &nbsp; Documentos
          <button
            data-toggle="modal"
            @click="buscarDocumentos"
            data-target="#documentos-modal"
            type="button"
            class="btn btn-primary btn-sm"
            style="margin-left: 15px"
          >
            <i class="fa-solid fa-plus"></i>
            Adicionar
          </button>
        </h5>
      </div>
      <div class="card-body table-responsive p-0">
        <table class="table table-hover">
          <thead>
            <tr>
              <th style="width: 25%">Novo nome</th>
              <th style="width: 25%">Tipo doc</th>
              <th style="width: 25%">Status</th>
              <th style="width: 25%">Validade</th>
              <th>Justificativa</th>
              <th style="width: 25%">Pendência</th>
              <th style="width: 25%">Visualizar</th>
              <th style="width: 25%">Revisar</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="document in my_user_documents" :key="document">
              <td data-label="Nome">
                <div v-if="!document.edit">
                  {{ document.nome }}
                  <i
                    class="fa fa-pen"
                    @click="(document.edit = true), (document.nome_edit = document.nome)"
                    style="cursor: pointer; margin-left: 5px"
                  ></i>
                </div>
                <form v-on:submit.prevent="editarNomeDocumento(document)" v-if="document.edit">
                  <div class="input-group">
                    <div class="input-group input-group-sm">
                      <input
                        style="width: 50%; max-width: 150px; font-size: 15px; max-height: 26px"
                        type="text"
                        class="form-control"
                        v-model="document.nome_edit"
                        @click="document.edit = true"
                      />

                      <span class="input-group-append">
                        <button style="max-height: 26px" @click="editarNomeDocumento(document)" type="button" class="btn btn-info btn-flat">
                          <i class="fa fa-check"></i>
                        </button>
                      </span>
                    </div>
                  </div>
                </form>
              </td>

              <td data-label="Tipo documento">
                {{ document.tipodoc }}

                <i
                  class="fa fa-pen"
                  data-toggle="modal"
                  data-target="#editar-documento-modal"
                  @click="(editar_doc = document), buscarDocumentos()"
                  style="cursor: pointer; margin-left: 5px"
                ></i>
              </td>

              <td data-label="Status" :style="getStyle(document.verificado)">
                {{ convertStatus(document.verificado) }}
              </td>

              <td data-label="Status">
                <span class="right badge badge-success" :style="getStyleValidate(document)">
                  {{ converterValidade(document) }}
                </span>
              </td>

              <td data-label="Justificativa" style="max-width: 200px !important; word-wrap: break-word !important">
                {{ document.justificativa }}
              </td>

              <td data-label="Pendência">
                <button @click="gerarEmail()" type="button" class="btn btn-primary btn-sm">Pendência</button>
              </td>

              <td data-label="Visualizar">
                <button
                  data-toggle="modal"
                  data-target="#visualizar-modal"
                  @click="selecionarDocumento(document)"
                  type="button"
                  class="btn btn-primary btn-sm"
                >
                  <i class="fa fa-search"></i>
                </button>
              </td>

              <td data-label="Visualizar">
                <a class="btn btn-success btn-sm" :href="getUrlDocument(document)">Revisar</a>
              </td>

              <td>
                <button
                  style="background-color: #d43f3a; border-color: #d43f3a"
                  @click="confirmarDelete(document, 'documento')"
                  type="button"
                  class="btn btn-danger btn-sm"
                >
                  Deletar
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- HABILITAÇÕES -->
    <div class="card card-primary">
      <div class="card-header">
        <h5 class="card-title" id="accordion">
          <i class="fa-solid fa-comment"></i>
          &nbsp; Habilitações

          <button
            @click="cadastrar_habilitacao_manual = true"
            data-toggle="modal"
            data-target="#habilitacao-manual-modal"
            type="button"
            class="btn btn-primary btn-sm"
            style="margin-left: 15px"
          >
            <i class="fa-solid fa-plus"></i>
            Habilitar manualmente
          </button>
        </h5>
      </div>

      <div class="card-body table-responsive p-2">
        <table class="table table-hover" style="position: relative">
          <thead>
            <tr>
              <th style="width: 15px !important">Seq</th>
              <th style="width: 55% !important">Leilão</th>
              <th style="width: 40% !important">Solicitação</th>
              <th style="width: 15px !important">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(habilitacao, index) in habilitacoes" :key="habilitacao">
              <td data-label="Seq">{{ index + 1 }}</td>

              <td data-label="Leilão">
                <div>
                  <b>Leilão:&nbsp;</b>
                  <a href="#" data-toggle="modal" data-target="#detalhes-leilao-modal" @click="objeto_leilao_selecionado = habilitacao">
                    {{ habilitacao.leilao_id }} - {{ habilitacao.leilao_titulo }}

                    <span
                      style="margin-left: 5px; text-transform: uppercase"
                      v-if="habilitacao.possui_lote_sucata_restricao > 0"
                      class="right badge badge-warning"
                    >
                      Contém sucata
                    </span>
                  </a>
                </div>
                <div>
                  <b>Dt. Próx Praça:</b>
                  {{ getDataProximaPraca(habilitacao) }}
                </div>
                <div>
                  <b>Comitente:</b>
                  {{ habilitacao.comitente }} - {{ habilitacao.cidade_comitente }}/{{ habilitacao.estado_comitente }}
                </div>
              </td>

              <td data-label="Solicitação">
                <div>
                  <b>Data:&nbsp;</b>
                  {{ formatDateTime(habilitacao.created_at) }}
                </div>
                <div>
                  <b>IP:&nbsp;</b>
                  {{ habilitacao.ip }}
                </div>
                <div>
                  <b>Status habilitação:&nbsp;</b>

                  <span style="text-transform: uppercase" v-if="habilitacao.status == 'liberado'" class="right badge badge-success">
                    {{ habilitacao.status }}
                  </span>

                  <span style="text-transform: uppercase" v-if="habilitacao.status == 'bloqueado'" class="right badge badge-danger">
                    {{ habilitacao.status }}
                  </span>

                  <span style="text-transform: uppercase" v-if="habilitacao.status == 'aguardando'" class="right badge badge-warning">
                    {{ habilitacao.status }}
                  </span>
                </div>

                <div
                  class="card"
                  style="margin-top: 5px; margin-top: 5px; margin-bottom: 5px; background-color: #dc3545 !important; color: white"
                  v-if="habilitacao.motivo_bloqueio"
                >
                  <div class="card-body p-2">
                    <i class="fa-solid fa-circle-exclamation" style="color: white"></i>
                    <b style="margin-left: 3px; font-size: 18px">Motivo bloqueio:</b>
                    <p style="margin-top: 5px; font-size: 18px; color: white">{{ habilitacao.motivo_bloqueio }}</p>
                  </div>
                </div>
              </td>

              <td>
                <a
                  id="navbarDropdown"
                  class="nav-link"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  v-pre
                >
                  <i class="fa-solid fa-bars" style="color: gray"></i>
                </a>

                <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right" aria-labelledby="navbarDropdown" ref="menu">
                  <div class="dropdown-divider"></div>
                  <a v-if="habilitacao.status != 'liberado'" @click="buscarEmail('Liberarhabilitacao', 'liberar', habilitacao)" class="dropdown-item">
                    LIBERAR
                  </a>
                  <div class="dropdown-divider"></div>
                  <a v-if="habilitacao.status != 'liberado'" @click="aprovar(0, habilitacao)" class="dropdown-item">LIBERAR SEM NOTIFICAR</a>
                  <div class="dropdown-divider"></div>
                  <a
                    v-if="habilitacao.status != 'bloqueado'"
                    @click="buscarEmail('Bloquearhabilitacao', 'bloquear', habilitacao)"
                    class="dropdown-item"
                  >
                    BLOQUEAR
                  </a>
                  <div class="dropdown-divider"></div>
                  <a v-if="habilitacao.status != 'bloqueado'" @click="bloquear(0, habilitacao)" class="dropdown-item">BLOQUEAR SEM NOTIFICAR</a>

                  <div v-if="habilitacao.motivo_bloqueio" class="dropdown-divider"></div>
                  <a v-if="habilitacao.motivo_bloqueio" class="dropdown-item" @click="removerMotivoBloqueio(habilitacao)" style="cursor: pointer">
                    REMOVER MOTIVO BLOQUEIO
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- MENU HABILITAÇÕES -->
        <div
          id="newMenu"
          style="visibility: hidden; position: absolute; background-color: white; max-width: 300px; line-height: 15px"
          class="dropdown-menu-lg dropdown-menu-right"
        >
          <div style="text-align: center; margin-top: 5px; margin-bottom: 5px">
            <b>Habilitação #{{ habilitacao_selecionada.id }}</b>
          </div>

          <div class="dropdown-divider"></div>
          <a class="dropdown-item" @click="buscarEmail('Liberarhabilitacao', 'liberar')" style="cursor: pointer">LIBERAR</a>

          <div class="dropdown-divider"></div>
          <a class="dropdown-item" @click="aprovar(0)" style="cursor: pointer">LIBERAR SEM NOTIFICAR</a>
        </div>
        <div
          id="newMenuBloquear"
          style="visibility: hidden; position: absolute; background-color: white; max-width: 300px; line-height: 15px"
          class="dropdown-menu-lg dropdown-menu-right"
        >
          <div style="text-align: center; margin-top: 5px; margin-bottom: 5px">
            <b>Habilitação #{{ habilitacao_selecionada.id }}</b>
          </div>

          <div class="dropdown-divider"></div>
          <a class="dropdown-item" @click="buscarEmail('Bloquearhabilitacao', 'bloquear')" style="cursor: pointer">BLOQUEAR</a>

          <div class="dropdown-divider"></div>
          <a class="dropdown-item" @click="bloquear(0)" style="cursor: pointer">BLOQUEAR SEM NOTIFICAR</a>
        </div>
      </div>
    </div>

    <!-- MENU ARREMATES -->
    <div class="card card-primary">
      <div class="card-header">
        <h5 class="card-title" id="accordion">
          <i class="fa-solid fa-comment"></i>
          &nbsp; Arremates
        </h5>
      </div>
      <div class="card-body table-responsive p-2">
        <table class="table table-hover" style="position: relative" v-if="lotes_arrematados">
          <thead>
            <tr>
              <th style="width: 15px !important">Seq</th>
              <th>DataHora</th>
              <th>Leilão</th>
              <th>Lote</th>
              <th>Praça</th>
              <th>Valor de arremate</th>
              <th>Parcelado</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(arremate, index) in lotes_arrematados" :key="arremate">
              <td>{{ index + 1 }}</td>

              <td>
                <div>
                  {{ formatDateTime(arremate.lote_lance_data) }}
                </div>
              </td>

              <td>
                <div>{{ arremate.leilao_id }} - {{ arremate.leilao_titulo }}</div>
              </td>
              <td>
                <div>{{ arremate.lote_numero }} - {{ arremate.lote_titulo }}</div>
              </td>
              <td>
                <div>
                  {{ arremate.lote_lance_praca }}
                </div>
              </td>
              <td>
                <div>R$ {{ toCurrency(arremate.lote_lance) }}</div>
              </td>
              <td>
                <span v-if="arremate.lote_ultimo_lance_parcelado == 1">Sim</span>
                <span v-else>Não</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- PROPOSTAS -->
    <div class="card card-primary">
      <div class="card-header">
        <h5 class="card-title" id="accordion">
          <i class="fa-solid fa-comment"></i>
          &nbsp; Últimas 10 propostas
        </h5>
      </div>
      <div class="card-body table-responsive p-2">
        <table class="table table-hover" style="position: relative" v-if="propostas">
          <thead>
            <tr>
              <th style="width: 15px !important">Seq</th>
              <th style="width: 55% !important">Leilão</th>
              <th style="width: 40% !important">Proposta</th>
              <th style="width: 15px !important">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(proposta, index) in propostas" :key="proposta">
              <td data-label="Seq">{{ index + 1 }}</td>

              <td data-label="Leilão/Lote">
                <div>
                  <b>Leilão:&nbsp;</b>
                  <a href="#" data-toggle="modal" data-target="#detalhes-leilao-modal" @click="objeto_leilao_selecionado = proposta">
                    {{ proposta.leilao_id }} - {{ proposta.leilao_titulo }}
                  </a>
                </div>
                <div>
                  <b>Lote:&nbsp;</b>
                  <a>{{ proposta.lote_id }} - {{ proposta.lote_titulo }}</a>
                </div>
                <div>
                  <b>Praça:&nbsp;</b>
                  {{ proposta.praca }}
                </div>
                <div>
                  <b>Data leilão:&nbsp;</b>
                  {{ formatDateTime(proposta.data_leilao) }}
                </div>
              </td>

              <td data-label="Proposta">
                <div style="text-transform: uppercase">
                  <b>Tipo:&nbsp;</b>
                  {{ proposta.tipo }}
                </div>
                <div>
                  <b>Aberto:&nbsp;</b>
                  {{ convertTiny(proposta.aberto) }}
                </div>
                <div>
                  <b>Data envio:&nbsp;</b>
                  {{ formatDateTime(proposta.created_at) }}
                </div>
                <div>
                  <br />
                </div>
                <div v-if="proposta.deleted_at">
                  <b>Proposta revogada em:&nbsp;</b>
                  {{ formatDateTime(proposta.deleted_at) }}
                </div>
              </td>

              <td>
                <a
                  id="navbarDropdown"
                  class="nav-link"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  v-pre
                >
                  <i class="fa-solid fa-bars" style="color: gray"></i>
                </a>

                <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right" aria-labelledby="navbarDropdown" ref="menu">
                  <div class="dropdown-divider"></div>
                  <a class="dropdown-item" @click="deletarProposta(proposta)" style="cursor: pointer">
                    <i class="fa-solid fa-trash"></i>
                    &nbsp;&nbsp; Revogar
                  </a>

                  <div class="dropdown-divider"></div>
                  <a
                    class="dropdown-item"
                    data-toggle="modal"
                    data-target="#visualizar-proposta-modal"
                    @click="(proposta_selecionada = proposta), (visualizar_proposta = true)"
                    style="cursor: pointer"
                  >
                    <i class="fa-solid fa-search"></i>
                    &nbsp;&nbsp; Visualizar
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- MODAL VISUALIZAR PROPOSTA -->
    <div
      class="modal fade"
      id="visualizar-proposta-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="margin-top: 30px"
      v-if="visualizar_proposta"
      @click.self="visualizar_proposta = false"
    >
      <form @submit.prevent>
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true" @click="visualizar_proposta = false">&times;</button>
              <h4>Proposta enviada</h4>
              <br />
              <div class="p-2">
                <proposta :proposta="objeto_leilao_selecionado" />
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <!-- MODAL HABILITAÇÃO MANUAL -->
    <div
      class="modal fade"
      id="habilitacao-manual-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      @click.self="cadastrar_habilitacao_manual = false"
      @keydown.esc="cadastrar_habilitacao_manual = false"
    >
      <form @submit.prevent>
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body" v-if="cadastrar_habilitacao_manual">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true" style="color: black">&times;</button>
              <admin-cadastrar-habilitacao-manual :user="user" :closeModal="closeModal" :acaoRealizada="acaoRealizada" />
            </div>
          </div>
        </div>
      </form>
    </div>

    <!-- MODAL EMAIL HABILITAÇÕES -->
    <div class="modal fade" id="email-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <form @submit.prevent>
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
              <h4>Email</h4>
              <br />

              <div class="col-sm-12">
                <div class="form-group">
                  <label for="leilao_info_geral">Assunto</label>

                  <input class="form-control" id="id" v-model="formData.assunto_email" />

                  <span style="color: red" v-for="error in v$.assunto_email.$errors" :key="error.$uid">
                    {{ error.$message }}
                  </span>
                </div>
              </div>

              <div class="col-sm-12">
                <div class="form-group">
                  <label for="leilao_info_geral">Conteúdo</label>

                  <Editor style="background-color: white" editorStyle="height: 200px" v-model="formData.corpo_email" />

                  <span style="color: red" v-for="error in v$.corpo_email.$errors" :key="error.$uid">
                    {{ error.$message }}
                  </span>
                </div>
              </div>

              <button @click="validate()" class="btn btn-primary btn-sm">Enviar e-mail e {{ acao }}</button>

              <button id="fechar_email_modal" style="margin-left: 15px" data-toggle="modal" data-target="#email-modal" class="btn btn-danger btn-sm">
                Fechar
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>

    <!-- NOTIFICAÇÕES 
    <div class="card card-primary">
      <div class="card-header">
        <h5 class="card-title" id="accordion">
          <i class="fa-solid fa-envelope"></i>
          &nbsp; Notificações
          <button
            class="btn btn-primary btn-sm"
            style="margin-left: 15px"
            id="notificacao_btn"
            data-target="#notificacao-modal"
            data-toggle="modal"
            type="button"
          >
            Cadastrar notificação
            <i class="fa fa-plus" style="margin-left: 5px"></i>
          </button>
        </h5>
      </div>

      <div class="card-body table-responsive p-0">
        <table class="table table-hover text-nowrap" v-if="notificacoes.length">
          <thead>
            <tr>
              <th style="width: 85%">Conteúdo</th>
              <th>Data criação</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="notificacao in notificacoes" :key="notificacao">
              <td data-label="Conteúdo">{{ notificacao.conteudo_text }}</td>

              <td data-label="Data criação">{{ formatDateTime(notificacao.created_at) }}</td>

              <td>
                <button
                  style="margin-left: 15px; background-color: #d43f3a; border-color: #d43f3a"
                  @click="confirmarDelete(notificacao, 'notificacao')"
                  type="button"
                  class="btn btn-danger btn-sm"
                >
                  Deletar
                  <i class="fa fa-trash" style="margin-left: 5px"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <tr v-else>
          <label style="margin-left: 15px; margin-top: 5px">Sem notificações...</label>
          <br />
        </tr>
      </div>
    </div>-->

    <!-- MODAL ANOTAÇÕES -->
    <div
      class="modal fade"
      id="anotacoes-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="margin-top: 30px"
    >
      <form @submit.prevent>
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
              <h4>Editar anotações</h4>
              <br />
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label for="nome" style="margin-bottom: 0px">Anotações internas:</label>

                    <textarea
                      id="justificativa"
                      name="justificativa"
                      rows="4"
                      cols="50"
                      class="form-control"
                      style="width: 100%"
                      v-model="anotacoes"
                    ></textarea>
                  </div>
                </div>
              </div>

              <button data-toggle="modal" class="btn btn-primary" @click="salvarAnotacoes">Salvar</button>
              <button style="margin-left: 15px" data-toggle="modal" id="fechar_anotacoes" data-target="#anotacoes-modal" class="btn btn-danger">
                Fechar
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>

    <!-- MODAL DOCUMENTOS -->
    <div
      class="modal fade"
      id="documentos-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="margin-top: 30px"
    >
      <form @submit.prevent>
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
              <h4>Documentos</h4>
              <br />
              <div class="card card-primary">
                <div class="card-body">
                  <div class="row">
                    <div class="col-6 col-sm-6 col-md-3">
                      <label for="exampleInputFile">Tipo documento</label>
                      <select class="custom-select rounded-0" id="documento" v-model="documento_selecionado">
                        <option v-for="doc_tipo_usuario in documentos_tipo_usuario" :key="doc_tipo_usuario" :value="doc_tipo_usuario">
                          {{ doc_tipo_usuario.tipodoc }}
                        </option>
                      </select>
                    </div>

                    <!-- ARQUIVO -->
                    <div class="col-sm-9">
                      <div class="form-group">
                        <label for="exampleInputFile">Arquivo</label>
                        <input class="form-control" type="file" @change="onChange" ref="file" />
                      </div>
                    </div>

                    <div class="col-sm-12"></div>
                  </div>
                </div>
                <!-- /.card-body -->

                <div class="card-footer">
                  <button data-toggle="modal" class="btn btn-primary" @click="sendFileS3">Salvar</button>
                  <button style="margin-left: 15px" data-toggle="modal" id="fechar_documentos" data-target="#documentos-modal" class="btn btn-danger">
                    Fechar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <!-- MODAL EDITAR DOCUMENTO -->
    <div
      class="modal fade"
      id="editar-documento-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="margin-top: 30px"
    >
      <form @submit.prevent>
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
              <h4>Editar documento</h4>
              <br />
              <div class="card card-primary">
                <div class="card-body">
                  <div class="row">
                    <div class="col-6 col-sm-6 col-md-6">
                      <label for="exampleInputFile">Tipo documento</label>
                      <select class="custom-select rounded-0" id="documento" v-model="editar_doc_tipo_selecionado">
                        <option v-for="doc_tipo_usuario in documentos_tipo_usuario" :key="doc_tipo_usuario" :value="doc_tipo_usuario">
                          {{ doc_tipo_usuario.tipodoc }}
                        </option>
                      </select>
                    </div>

                    <!-- ARQUIVO -->
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label for="exampleInputFile">Nome</label>
                        <input disabled class="form-control" v-model="editar_doc.nome" />
                      </div>
                    </div>

                    <div class="col-sm-12"></div>
                  </div>
                </div>
                <!-- /.card-body -->

                <div class="card-footer">
                  <button data-toggle="modal" class="btn btn-primary" @click="editarTipoDocumento">Salvar</button>
                  <button id="close_editar_tipodoc" style="margin-left: 15px" data-dismiss="modal" class="btn btn-danger">Fechar</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <!-- MODAL VISUALIZAR DOCUMENTO -->
    <div
      class="modal fade"
      id="visualizar-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="margin-top: 30px"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body" v-if="documento_selecionado">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h4>Documento enviado</h4>
            <br />
            <div class="card card-primary">
              <div class="card-body">
                <div class="tab-content p-0">
                  <object
                    :key="documento_selecionado"
                    v-if="file_type == 'pdf' || file_type == 'PDF'"
                    :data="getDocumentPath(documento_selecionado)"
                    type="application/pdf"
                    width="100%"
                    height="600px"
                  ></object>

                  <img v-else :src="getDocumentPath(documento_selecionado)" width="100%" />
                </div>
              </div>
              <!-- /.card-body -->

              <div class="card-footer">
                <button data-toggle="modal" id="cancelar" data-target="#visualizar-modal" class="btn btn-danger">Fechar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL CADASTRAR PENDÊNCIA E ENVIAR E-MAIL -->
    <div class="modal fade" id="pendencia-e-email-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <form @submit.prevent>
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
              <h4>Cadastrar pendência</h4>
              <br />

              <div class="col-sm-12">
                <div class="form-group">
                  <label for="leilao_info_geral">Assunto</label>
                  <input class="form-control" id="id" v-model="assunto_pendencia_e_email" />
                </div>
              </div>

              <div class="col-sm-12">
                <div class="form-group">
                  <label for="leilao_info_geral">Conteúdo</label>
                  <Editor style="background-color: white" editorStyle="height: 200px" v-model="corpo_pendencia_e_email" />
                </div>
              </div>

              <!-- PENDÊNCIAS -->
              <div class="col-sm-12">
                <div class="card card-primary">
                  <div class="card-header">
                    <h5 class="card-title" id="accordion">
                      <i class="fas fa-user"></i>
                      &nbsp; Pendências
                    </h5>
                  </div>

                  <div class="card-body table-responsive p-0">
                    <table class="table table-hover" v-if="pendencias.length">
                      <thead>
                        <tr>
                          <th style="width: 85%">Conteúdo</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="pendencia in pendencias" :key="pendencia">
                          <td data-label="Conteúdo">{{ getOnlyText(pendencia.conteudo) }}</td>
                        </tr>
                      </tbody>
                    </table>
                    <tr v-else>
                      <label style="margin-left: 15px; margin-top: 5px">Sem pendências...</label>
                      <br />
                    </tr>
                  </div>
                </div>
              </div>

              <button @click="cadastrarPendenciaEEmail()" class="btn btn-primary btn-sm">
                Gravar pendência e enviar e-mail
                <i class="fa fa-plus"></i>
              </button>

              <button
                id="fechar_pendencias_e_email"
                style="margin-left: 15px"
                data-toggle="modal"
                data-target="#pendencia-e-email-modal"
                class="btn btn-danger btn-sm"
              >
                Fechar
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>

    <!-- MODAL CADASTRAR PENDÊNCIA -->
    <div class="modal fade" id="pendencias-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <form @submit.prevent>
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
              <h4>Cadastrar pendência</h4>
              <br />

              <div class="col-sm-12">
                <div class="form-group">
                  <label for="leilao_info_geral">Conteúdo</label>
                  <Editor style="background-color: white" editorStyle="height: 200px" v-model="conteudo_pendencia" />
                </div>
              </div>

              <!-- PENDÊNCIAS -->
              <div class="col-sm-12">
                <div class="card card-primary">
                  <div class="card-header">
                    <h5 class="card-title" id="accordion">
                      <i class="fas fa-user"></i>
                      &nbsp; Pendências
                    </h5>
                  </div>

                  <div class="card-body table-responsive p-0">
                    <table class="table table-hover text-nowrap" v-if="pendencias.length">
                      <thead>
                        <tr>
                          <th style="width: 85%">Conteúdo</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="pendencia in pendencias" :key="pendencia">
                          <td data-label="Conteúdo">{{ getOnlyText(pendencia.conteudo) }}</td>
                        </tr>
                      </tbody>
                    </table>
                    <tr v-else>
                      <label style="margin-left: 15px; margin-top: 5px">Sem pendências...</label>
                      <br />
                    </tr>
                  </div>
                </div>
              </div>

              <button @click="cadastrarPendencia()" class="btn btn-primary btn-sm">
                Cadastrar
                <i class="fa fa-plus"></i>
              </button>

              <button
                id="fechar_pendencias"
                style="margin-left: 15px"
                data-toggle="modal"
                data-target="#pendencias-modal"
                class="btn btn-danger btn-sm"
              >
                Fechar
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>

    <!-- MODAL EMAIL DE PENDÊNCIAS -->
    <div class="modal fade" id="email-pendencias-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <form @submit.prevent>
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
              <h4>Email de pendências</h4>
              <br />

              <div class="col-sm-12">
                <div class="form-group">
                  <label for="leilao_info_geral">Assunto</label>
                  <input class="form-control" id="id" v-model="assunto_email_pendencias" />
                </div>
              </div>

              <div class="col-sm-12">
                <div class="form-group">
                  <label for="leilao_info_geral">Conteúdo</label>
                  <Editor style="background-color: white" editorStyle="height: 200px" v-model="corpo_email_pendencias" />
                </div>
              </div>

              <button @click="enviarEmailPendencias()" class="btn btn-primary btn-sm">Enviar e-mail</button>

              <button
                id="fechar_email_pendencias"
                style="margin-left: 15px"
                data-toggle="modal"
                data-target="#email-pendencias-modal"
                class="btn btn-danger btn-sm"
              >
                Fechar
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>

    <!-- MODAL CADASTRAR NOTIFICAÇÃO -->
    <div class="modal fade" id="notificacao-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <form @submit.prevent>
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
              <h4>Nova notificação</h4>
              <br />

              <div class="col-sm-12">
                <div class="form-group">
                  <label for="leilao_info_geral">Conteúdo</label>

                  <Editor
                    style="background-color: white"
                    editorStyle="height: 200px"
                    v-model="conteudo_notificacao"
                    id="conteudo_notificacao"
                    @text-change="changeTextNotificacao"
                  />
                </div>
              </div>
              <div class="col-sm-12">
                <!-- NOTIFICAÇÕES -->
                <div class="card card-primary">
                  <div class="card-header">
                    <h5 class="card-title" id="accordion">
                      <i class="fa-solid fa-envelope"></i>
                      &nbsp; Notificações
                    </h5>
                  </div>

                  <div class="card-body table-responsive p-0">
                    <table class="table table-hover text-nowrap" v-if="notificacoes.length">
                      <thead>
                        <tr>
                          <th style="width: 85%">Conteúdo</th>
                          <th style="width: 85%">Data criação</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="notificacao in notificacoes" :key="notificacao">
                          <td data-label="Conteúdo">{{ notificacao.conteudo_text }}</td>
                          <td data-label="Data criação">{{ formatDateTime(notificacao.created_at) }}</td>
                        </tr>
                      </tbody>
                    </table>
                    <tr v-else>
                      <label style="margin-left: 15px; margin-top: 5px">Sem notificações...</label>
                      <br />
                    </tr>
                  </div>
                </div>
              </div>
              <button @click="cadastrarNotificacao()" class="btn btn-primary btn-sm">
                Cadastrar
                <i class="fa fa-plus"></i>
              </button>

              <button
                id="fechar_notificacoes"
                style="margin-left: 15px"
                data-toggle="modal"
                data-target="#notificacao-modal"
                class="btn btn-danger btn-sm"
              >
                Fechar
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>

    <!-- MODAL EDITAR CADASTRO -->
    <admin-editar-cadastro
      v-if="editar_cadastro"
      :orgaos_expedidores_rg="orgaos_expedidores_rg"
      :user_profile="user_profile"
      :user="user"
      :estados="estados"
      :cidades="my_cidades"
      :close="close"
      :action="buscarUserProfile"
      :cidades_pj="my_cidades_pj"
    />
  </div>

  <div v-else>
    <h4>Usuário sem perfil cadastrado...</h4>
    <h4>Aguarde o preenchimento pelo usuário e tente novamente...</h4>
  </div>

  <!-- MODAL DETALHES LEILÃO -->
  <div class="modal fade" id="detalhes-leilao-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
    <form @submit.prevent>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="card">
              <div
                class="card-body"
                style="
                  padding: 0px 0px 0px 0px;
                  text-align: left;
                  font-family: 'Montserrat', sans-serif;
                  text-transform: uppercase;
                  margin: 0px 0px 0px 0px;
                "
              >
                <div style="text-align: left; line-height: 5px" class="p-2">
                  <div style="margin-top: 7px; position: relative">
                    <p style="font-size: 16px; font-weight: bold; word-wrap: break-word">
                      {{ objeto_leilao_selecionado.cidade_leilao }} - {{ objeto_leilao_selecionado.estado_leilao }}
                    </p>
                    <span style="font-size: 15px; font-weight: bold; margin-top: 4px">
                      {{ getFormatedTitle(objeto_leilao_selecionado.leilao_titulo) }}
                    </span>
                    <br />
                  </div>
                </div>

                <div style="line-height: 15px; margin-top: 5px; text-align: left" class="p-2">
                  <b style="font-size: 14px">
                    Modalidade:
                    <a style="color: #4a4949; font-weight: 400">{{ objeto_leilao_selecionado.leilao_1_modalidade }}</a>
                  </b>
                  <br />
                  <b style="font-size: 14px">
                    Local:
                    <a style="color: #4a4949; font-weight: 400; text-transform: none">{{ objeto_leilao_selecionado.leilao_local }}</a>
                  </b>
                </div>
                <!-- DATAS E VALORES DOS LEILÕES -->
                <div v-if="objeto_leilao_selecionado.leilao_num_pracas > 1 && !venda_direta" style="text-align: left; line-height: 15px" class="p-2">
                  <div style="font-size: 14px; color: #545353" :class="objeto_leilao_selecionado.leilao_1_realizado === 1 ? 'realizado' : ''">
                    <b>1º Leilão:</b>
                    {{ formatDate(objeto_leilao_selecionado.leilao_1_data) + "h" }}
                  </div>

                  <!-- DATA 2 -->
                  <div style="font-size: 14px; color: #545353" v-if="objeto_leilao_selecionado.leilao_num_pracas >= 2">
                    <b>2º Leilão:</b>
                    {{ formatDate(objeto_leilao_selecionado.leilao_2_data) + "h" }}
                  </div>

                  <!-- DATA 3 -->
                  <div style="font-size: 14px; color: #545353" v-if="objeto_leilao_selecionado.leilao_num_pracas >= 3">
                    <b>3º Leilão:</b>
                    {{ formatDate(objeto_leilao_selecionado.leilao_3_data) + "h" }}
                  </div>

                  <!-- DATA 4 -->
                  <div style="font-size: 14px; color: #545353" v-if="objeto_leilao_selecionado.leilao_num_pracas >= 4">
                    <b>4º Leilão:</b>
                    {{ formatDate(objeto_leilao_selecionado.leilao_4_data) + "h" }}
                  </div>
                </div>

                <!-- ÚNICO LEILÃO-->
                <div
                  v-else-if="objeto_leilao_selecionado.leilao_num_pracas == 1 && !venda_direta"
                  style="padding-left: 8px !important; text-align: left; line-height: 15px; margin-top: 5px"
                  class="p-1"
                >
                  <div
                    style="font-size: 14px; color: #545353; margin-bottom: 3px"
                    :class="objeto_leilao_selecionado.leilao_1_realizado === 1 ? 'realizado' : ''"
                  >
                    <b>Único leilão:</b>
                    {{ formatDate(objeto_leilao_selecionado.leilao_1_data) + "h" }}
                  </div>
                </div>

                <!-- VENDA DIRETA-->
                <div v-else-if="venda_direta" style="text-align: center; line-height: 15px; text-transform: none" class="p-1">
                  <p style="font-size: 14px; margin-top: 5px">{{ objeto_leilao_selecionado.leilao_local }}</p>
                  <div style="font-size: 14px; color: #545353" :class="objeto_leilao_selecionado.leilao_1_realizado === 1 ? 'realizado' : ''">
                    <b style="">Disponível até:</b>
                    {{ formatDate(objeto_leilao_selecionado.leilao_1_data) + "h" }}
                    <br />
                    <a>Pelo valor de</a>
                    R$ {{ toCurrency(lote_selecionado.lote_valor_1) }}
                  </div>
                </div>

                <!-- ID DO LEILÃO-->
                <span class="p-2" style="font-size: 15px; font-weight: bold; margin-top: 4px">
                  Leilão ID {{ objeto_leilao_selecionado.leilao_id }}
                  <!--
                  <a :href="'/admin/leilao/' + objeto_leilao_selecionado.leilao_id">
                    {{ objeto_leilao_selecionado.leilao_id }}
                  </a>
                  -->

                  <a style="margin-left: 5px" @click="getUrlLeilao(objeto_leilao_selecionado)" href="#">Site</a>
                </span>

                <button
                  style="font-size: 12px; border-radius: 2px; margin-left: 5px; margin-bottom: 12px"
                  type="submit"
                  class="btn btn-default"
                  title="Habilitações"
                  alt="Habilitações"
                >
                  <div>
                    <i class="fa-solid fa-laptop"></i>
                    {{ objeto_leilao_selecionado.total_habilitacoes }}
                  </div>
                </button>
              </div>
            </div>

            <button data-dismiss="modal" class="btn btn-danger btn-sm">Fechar</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import auxFormatacao from "../../controller/auxFormatacao";
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AuxController from "../../mixins/auxController.js";
import Loading from "vue-loading-overlay";
import moment from "moment";
import "vue-loading-overlay/dist/vue-loading.css";
import Editor from "primevue/editor";
import InputMask from "primevue/inputmask";

import useVueLidate from "@vuelidate/core";
import { computed, reactive } from "vue";
import { required } from "../../locales/i18n.js";

export default {
  props: ["cidades", "estados", "cidades_pj", "user_documents", "my_user_profile", "my_user", "orgaos_expedidores_rg", "url_voltar"],

  mixins: [sweetAlert, Swal, AuxController, auxFormatacao],

  components: { Loading, Editor, InputMask },

  data() {
    return {
      habilitacao_selecionada: "",
      conteudo_notificacao: "",
      conteudo_notificacao_text: "",
      habilitacoes: [],
      propostas: [],
      notificacoes: [],
      conteudo_pendencia: "",
      pendencias: [],
      isLoading: false,
      doc_tipo_usuario_selecionado: "",
      qtd_por_pagina: 25,
      pagina_atual: 1,
      inicio: 0,
      paginas: [],
      total: 0,
      users: [],
      verificado: "",
      reason: "",
      file_type: "",
      documento_selecionado: "",
      user: "",
      editar_cadastro: false,
      user_profile: "",
      acao_necessaria: "",
      anotacoes: "",
      documentos_tipo_usuario: "",
      upload_files: "",
      corpo_email_pendencias: "",
      assunto_email_pendencias: "",
      my_user_documents: "",
      editar_anotacoes: false,
      my_cidades: "",
      my_cidades_pj: "",
      mail_template: "",
      acao: "",
      visualizar_proposta: false,
      cadastro_selecionado: "",
      assunto_pendencia_e_email: "",
      corpo_pendencia_e_email: "",
      objeto_leilao_selecionado: "",
      cadastrar_habilitacao_manual: "",
      venda_direta: "",
      editar_doc: "",
      editar_doc_tipo_selecionado: "",
      lotes_arrematados: [],
    };
  },

  setup() {
    const formData = reactive({
      assunto_email: "",
      corpo_email: "",
      rodape_email: "",
    });

    const rules = computed(() => {
      return {
        corpo_email: { required },
        assunto_email: { required },
      };
    });

    const aceitarTermos = (value) => {
      return value;
    };

    const v$ = useVueLidate(rules, formData);

    return { formData, v$ };
  },

  mounted() {
    console.log(this.document);
    console.log(this.verificado);

    this.my_cidades = this.cidades;
    this.my_cidades_pj = this.cidades_pj;
    this.user_profile = this.my_user_profile;

    console.log("Profile");
    console.log(this.user_profile);

    this.my_user_documents = this.user_documents;

    this.buscarUsuario(() => {
      this.buscarHabilitacoes();
      this.buscarPendencias();
      this.buscarNotificacoes();
      this.buscarPropostas();
      this.buscarLotesArrematados();

      this.anotacoes = this.user.observacoes;
    });
  },

  methods: {
    getUrlLeilao(habilitacao) {
      if (habilitacao.total_lotes > 1) {
        window.open("/leilao/" + habilitacao.leilao.id + "/lotes");
      } else {
        window.open("/lote/" + habilitacao.primeiro_lote_id);
      }
    },

    limparAnotacoes() {
      this.$swal
        .fire({
          title: "<h3 style='color:#616060'>Tem certeza que deseja limpar as anotações deste cadastro?</h3>",
          icon: "warning",
          padding: "1.5em",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim!",
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;

            let data = {
              user_id: this.user.id,
            };

            axios
              .post(`/admin/user/atualizarAnotacoes`, data)
              .then((response) => {
                this.isLoading = false;
                this.showSuccessMessageWithButtonAndReload("Sucesso", "Anotações limpas!");
              })
              .catch((error) => {
                this.isLoading = false;
                this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
                console.log(error.response.data);
              });
          }
        });
    },

    editarTipoDocumento() {
      console.log("Editando documento ");
      console.log(this.editar_doc_tipo_selecionado);
      console.log(this.editar_doc);

      let data = {
        documento_id: this.editar_doc.id,
        tipodoc: this.editar_doc_tipo_selecionado.tipodoc,
      };

      console.log(data);

      axios
        .post(`/admin/document/update`, data)
        .then((response) => {
          if (response.data.success) {
            this.editar_doc.tipodoc = this.editar_doc_tipo_selecionado.tipodoc;

            let btn = document.getElementById("close_editar_tipodoc");
            btn.click();

            this.showSuccessMessage("Documento atualizado");
          } else {
            this.showErrorMessageWithButton("Ops...", response.data.msg);
          }
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    editarNomeDocumento(documento) {
      console.log("Editando documento ");
      console.log(documento);
      documento.edit = false;

      let data = {
        documento_id: documento.id,
        nome: documento.nome_edit,
      };

      console.log(data);

      axios
        .post(`/admin/document/rename`, data)
        .then((response) => {
          if (response.data.success) {
            this.showSuccessMessage("Nome atualizado");

            documento.nome = documento.nome_edit;
          } else {
            this.showErrorMessageWithButton("Ops...", response.data.msg);
          }
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    acaoRealizada(acao) {
      if (acao == "cadastrar_habilitacao") {
        this.closeModal();
        this.buscarHabilitacoes();
      }
    },

    closeModal() {
      this.cadastrar_habilitacao_manual = false;
    },

    getFormatedTitle(title) {
      if (title && title.length > 30) {
        return title.substring(0, 30) + "...";
      } else {
        return title;
      }
    },

    removerMotivoBloqueio(habilitacao) {
      this.habilitacao_selecionada = habilitacao;

      this.isLoading = true;

      let data = {
        habilitacao_id: this.habilitacao_selecionada.id,
        motivo_pendencia: this.motivo_pendencia,
        motivo_bloqueio: null,
      };

      axios
        .post(`/admin/habilitacoes/update_pendencia`, data)
        .then((response) => {
          this.isLoading = false;
          this.showSuccessMessageWithButton("Sucesso", "Motivo de bloqueio removido.");
          this.buscarHabilitacoes();
        })
        .catch((error) => {
          this.isLoading = false;
          if (typeof error == "object") {
            this.showErrorMessageWithButton("Ops..", error.response.data.message);
          } else {
            this.showErrorMessageWithButton("Ops..", error);
          }
        });
    },

    getOnlyText(text) {
      if (typeof text == "string" && text.includes("</")) {
        var div = document.createElement("div");
        div.innerHTML = text;
        text = div.textContent || div.innerText || "";
      }

      return text;
    },

    buscarEmailPendencia() {
      let data = {
        tipo: "Pendenciasuser",
      };

      console.log("BUSCANDO E-MAIL");

      axios
        .post(`/admin/mail_template/find_by_tipo`, data)
        .then((response) => {
          console.log("Sucesso buscado");
          console.log(response.data);

          if (response.data.mail_template) {
            this.assunto_pendencia_e_email = response.data.mail_template.assunto;
            this.corpo_pendencia_e_email = response.data.mail_template.corpo + response.data.mail_template.rodape;
          } else {
            this.showErrorMessageWithButton("Ops...", "Email sem corpo ou sem assunto");
          }
        })
        .catch((error) => {
          console.log("Erro buscado");
          console.log(error);
          this.isLoading = false;
        });
    },

    buscarEmailNotificacao() {
      let data = {
        tipo: "Notificaruser",
      };

      console.log("BUSCANDO E-MAIL");

      axios
        .post(`/admin/mail_template/find_by_tipo`, data)
        .then((response) => {
          console.log("Sucesso buscado");

          if (response.data.mail_template) {
            //this.assunto_email_pendencias = response.data.mail_template.assunto;

            this.conteudo_notificacao = response.data.mail_template.corpo + response.data.mail_template.rodape;
          } else {
            this.showErrorMessageWithButton("Ops...", "Email sem corpo ou sem assunto");
          }
        })
        .catch((error) => {
          console.log("Erro buscado");
          console.log(error);
          this.isLoading = false;
        });
    },

    getStyleOnline(user) {
      let online = false;

      if (user.last_seen) {
        let dataReferencia = moment(new Date());
        let data = moment(user.last_seen);

        var duration = moment.duration(dataReferencia.diff(data));
        var min = duration.asMinutes();

        if (min <= 5) {
          online = true;
        }
      }

      if (online) {
        return "color: #007d41";
      } else {
        return "color: gray;";
      }
    },

    changeTextNotificacao(textValue) {
      this.conteudo_notificacao_text = textValue.textValue;
    },

    editarAnotacoes() {
      this.editar_anotacoes = true;

      setTimeout(() => {
        document.getElementById("text_anotacoes").focus();
      }, "1 second");
    },

    gerarEmail() {
      console.log(this.user_documents);

      this.corpo_email_pendencias = "<p>Arquivos reprovados:</p> <br/>";

      let contPendentes = 0;
      let contExpirados = 0;

      let docs_expirados = [];

      for (let i = 0; i < this.user_documents.length; i++) {
        let document = this.user_documents[i];

        if (document.verificado == 2) {
          if (contPendentes > 0) {
            this.corpo_email_pendencias = this.corpo_email_pendencias + "<br/>";
          }

          contPendentes++;
          this.corpo_email_pendencias =
            this.corpo_email_pendencias +
            "<p>Tipo: " +
            document.tipodoc +
            "</p><p>Nome: " +
            document.nome +
            "</p><p><strong>Justificativa: </strong>" +
            document.justificativa +
            "</p>";
        }

        let expirado = this.checkVencido(document);

        if (expirado) {
          docs_expirados.push(document);
          contExpirados++;
        }
      }

      if (contExpirados > 0) {
        this.corpo_email_pendencias = this.corpo_email_pendencias + "<br/><p>Comprovantes vencidos:</p><br/><br/>";
      }

      for (let i = 0; i < docs_expirados.length; i++) {
        let document = docs_expirados[i];

        if (contExpirados > 0 && i > 0) {
          this.corpo_email_pendencias = this.corpo_email_pendencias + "<br/>";
        }

        this.corpo_email_pendencias =
          this.corpo_email_pendencias +
          "<p>Tipo: " +
          document.tipodoc +
          "</p><p>" +
          document.nome +
          "</p><p><strong>Justificativa: </strong> " +
          document.justificativa +
          "</p>";
      }

      if (contPendentes > 0 || contExpirados > 0) {
        let data = {
          tipo: "Pendenciasuser",
        };

        axios
          .post(`/admin/mail_template/find_by_tipo`, data)
          .then((response) => {
            if (response.data.mail_template) {
              this.assunto_email_pendencias = response.data.mail_template.assunto;

              let btn = document.getElementById("fechar_email_pendencias");
              btn.click();
            } else {
              this.showErrorMessageWithButton("Ops...", "Email sem corpo ou sem assunto");
            }
          })
          .catch((error) => {
            console.log(error);
            this.isLoading = false;
          });
      } else {
        this.showErrorMessageWithButton("Ops...", "Nenhum documento com pendência");
      }
    },

    checkVencido(documento) {
      let data = this.formatDate(documento.expira_em);

      if (data != "Invalid date") {
        let vencido = new Date() >= new Date(documento.expira_em);

        return vencido;
      } else {
        return false;
      }
    },

    close() {
      setTimeout(() => {
        this.editar_cadastro = false;
      }, "1 second");
    },

    getUrlDocument(document) {
      return "/admin/cadastros/detalhes/" + this.user.id + "/document/" + document.id;
    },

    onChange(e) {
      this.upload_files = e.target.files[0];
    },

    enviarEmailPendencias() {
      if (this.assunto_email_pendencias == "" || !this.assunto_email_pendencias) {
        this.showErrorMessageWithButton("Ops...", "Preencha o campo assunto");
      } else {
        this.isLoading = true;

        let data = {
          user_id: this.user.id,
          corpo: this.corpo_email_pendencias,
          assunto: this.assunto_email_pendencias,
        };

        console.log(data);

        axios
          .post(`/admin/pendencia/enviar_email`, data)
          .then((response) => {
            this.isLoading = false;

            let btn = document.getElementById("fechar_email_pendencias");
            btn.click();

            this.showSuccessMessage("E-mail enviado");
          })
          .catch((error) => {
            console.log(error);
            this.isLoading = false;
          });
      }
    },

    buscarDocumentos(callback) {
      console.log(this.$refs);
      this.documento_selecionado = null;
      this.$refs.file.value = null;
      this.upload_files = null;

      this.isLoading = true;

      let data = {
        user_id: this.user.id,
      };

      console.log("Id");
      console.log(this.user.id);

      axios
        .post(`/admin/documentos_tipo_usuario/search_by_user`, data)
        .then((response) => {
          this.documentos_tipo_usuario = [];

          console.log(response.data);

          let docs = response.data.documentos;

          if (docs) {
            this.documentos_tipo_usuario = docs;

            /*
                        for (let i = 0; i < docs.length; i++) {
                            let indice = this.findTipodoc(docs[i].tipodoc);

                            if (indice < 0) {
                                this.documentos_tipo_usuario.push(docs[i]);
                            }
                        }*/
          }

          this.isLoading = false;

          if (callback) {
            callback();
          }
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
        });
    },

    findTipodoc(tipodoc) {
      let indice = this.user_documents.findIndex((element) => element["tipodoc"] == tipodoc);

      return indice;
    },

    salvarAnotacoes() {
      this.isLoading = true;

      let data = {
        user_id: this.user.id,
        anotacoes: this.anotacoes,
      };

      console.log("CADASTRANDO NOTIFICAÇÃO");
      console.log(data);

      axios
        .post(`/admin/user/atualizarAnotacoes`, data)
        .then((response) => {
          this.isLoading = false;

          let btn = document.getElementById("fechar_anotacoes");
          btn.click();

          this.editar_anotacoes = false;

          this.user.observacoes = this.anotacoes;

          this.showSuccessMessageWithButtonAndReload("Sucesso!", "Anotações atualizadas!");
        })
        .catch((error) => {
          console.log(error);
          this.showErrorMessageWithButton("Ops..", "Falha ao cadastrar anotações");
          this.isLoading = false;
        });

      console.log(this.acao_necessaria);
    },

    async validate() {
      const result = await this.v$.$validate();

      if (result) {
        if (this.acao == "liberar") {
          this.aprovar(1, this.habilitacao_selecionada);
        } else if (this.acao == "bloquear") {
          this.bloquear(1, this.habilitacao_selecionada);
        }
      }
    },

    bloquear(notificar, habilitacao) {
      if (notificar) {
        document.getElementById("fechar_email_modal").click();
      }

      this.$swal
        .fire({
          title: "Motivo do bloqueio",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          html: '<label for="rejeicao">Motivo da rejeição:</label>' + '<textarea id="rejeicao" class="form-control" value="">',
          focusConfirm: false,
          preConfirm: () => {
            return [document.getElementById("rejeicao").value];
          },
        })
        .then((response) => {
          console.log("Response bloqueio");
          console.log(response);

          if (response.isConfirmed) {
            this.habilitacao_selecionada = habilitacao;
            this.isLoading = true;

            let data = {
              habilitacao_id: this.habilitacao_selecionada.id,
              status: "bloqueado",
              notificar: notificar,
              corpo: this.formData.corpo_email,
              assunto: this.formData.assunto_email,
              motivo_bloqueio: response.value[0],
            };

            axios
              .post(`/admin/habilitacao/bloquear`, data)
              .then((response) => {
                this.isLoading = false;
                if (response.data.success) {
                  let msg = "Habilitação bloqueada com sucesso.";

                  if (response.data.habilitacoes_pendentes == 1) {
                    msg = msg + "<br/>Este usuário possui mais <br/><b>" + response.data.habilitacoes_pendentes + " habilitação pendente.</b>";
                  } else if (response.data.habilitacoes_pendentes > 1) {
                    msg = msg + "<br/>Este usuário possui mais <br/><b>" + response.data.habilitacoes_pendentes + " habilitações pendentes.</b>";
                  }

                  this.showSuccessMessageWithButtonAndReloadHtml("Sucesso", msg);
                } else {
                  this.showErrorMessageWithButton("Ops...", response.data.msg);
                }
              })
              .catch((error) => {
                this.isLoading = false;
                if (typeof error == "object") {
                  console.log("Erro");
                  console.log(error);

                  if (error.response.data.message == "User is not logged in.") {
                    this.showErrorMessageWithButtonAndReload("Ops..", "Favor logar no sistema antes de continuar.", "/login");
                  } else {
                    this.showErrorMessageWithButton("Ops..", error.response.data.message);
                  }
                } else {
                  this.showErrorMessageWithButton("Ops..", error);

                  console.log(error.response.data);
                }
              });
          }
        });
    },

    aprovar(notificar, habilitacao) {
      this.habilitacao_selecionada = habilitacao;
      this.isLoading = true;

      let data = {
        habilitacao_id: this.habilitacao_selecionada.id,
        status: "liberado",
        notificar: notificar,
        corpo: this.formData.corpo_email,
        assunto: this.formData.assunto_email,
      };

      axios
        .post(`/admin/habilitacao/aprovar`, data)
        .then((response) => {
          this.isLoading = false;
          if (response.data.success) {
            let msg = "Usuário habilitado com sucesso.";

            if (response.data.habilitacoes_pendentes == 1) {
              msg = msg + "<br/>Este usuário possui mais <br/><b>" + response.data.habilitacoes_pendentes + " habilitação pendente.</b>";
            } else if (response.data.habilitacoes_pendentes > 1) {
              msg = msg + "<br/>Este usuário possui mais <br/><b>" + response.data.habilitacoes_pendentes + " habilitações pendentes.</b>";
            }

            this.showSuccessMessageWithButtonAndReloadHtml("Sucesso", msg);
          } else {
            this.showErrorMessageWithButton("Ops...", response.data.msg);
          }
        })
        .catch((error) => {
          this.isLoading = false;
          if (typeof error == "object") {
            console.log("Erro");
            console.log(error);

            if (error.response.data.message == "User is not logged in.") {
              this.showErrorMessageWithButtonAndRedirect("Ops..", "Favor logar no sistema antes de continuar.", "/login");
            } else {
              this.showErrorMessageWithButton("Ops..", error.response.data.message);
            }
          } else {
            this.showErrorMessageWithButton("Ops..", error);

            console.log(error.response.data);
          }
        });
    },

    buscarEmail(tipo, acao, habilitacao) {
      this.acao = acao;
      this.habilitacao_selecionada = habilitacao;

      let data = {
        tipo: tipo,
      };

      axios
        .post(`/admin/mail_template/find_by_tipo`, data)
        .then((response) => {
          let btn = document.getElementById("fechar_email_modal").click();

          this.mail_template = response.data.mail_template;

          this.formData.assunto_email = this.mail_template.assunto;
          this.formData.corpo_email = this.mail_template.corpo + this.mail_template.rodape;
          this.formData.rodape_email = this.mail_template.rodape;

          console.log(this.mail_template);
        })
        .catch((error) => {
          if (typeof error == "object") {
            this.showErrorMessageWithButton("Ops..", error.response.data.message);
          } else {
            this.showErrorMessageWithButton("Ops..", error);
          }
        });
    },

    getDataProximaPraca(habilitacao) {
      if (habilitacao.leilao_oculto || habilitacao.leilao_retirado || habilitacao.leilao_suspenso || habilitacao.leilao_encerrado) {
        return "";
      } else if (habilitacao.leilao_num_pracas >= 1 && habilitacao.leilao_1_realizado == 0) {
        return this.formatDateTime(habilitacao.leilao_1_data);
      } else if (habilitacao.leilao_num_pracas >= 2 && habilitacao.leilao_2_realizado == 0) {
        return this.formatDateTime(habilitacao.leilao_2_data);
      } else if (habilitacao.leilao_num_pracas >= 3 && habilitacao.leilao_3_realizado == 0) {
        return this.formatDateTime(habilitacao.leilao_3_data);
      } else if (habilitacao.leilao_num_pracas >= 4 && habilitacao.leilao_4_realizado == 0) {
        return this.formatDateTime(habilitacao.leilao_4_data);
      }
    },

    cadastrarNotificacao() {
      if (this.conteudo_notificacao != "") {
        this.isLoading = true;

        let data = {
          user_id: this.user.id,
          conteudo: this.conteudo_notificacao,
          conteudo_text: this.conteudo_notificacao_text,
        };

        console.log("CADASTRANDO NOTIFICAÇÃO");
        console.log(data);
        console.log(conteudo_notificacao.textValue);

        axios
          .post(`/admin/notificacoes/store`, data)
          .then((response) => {
            this.isLoading = false;

            if (response.data.success) {
              let btn = document.getElementById("fechar_notificacoes");

              btn.click();

              this.showSuccessMessage("Notificação cadastrada!");

              this.buscarNotificacoes();

              if (this.acao_necessaria && this.acao_necessaria != "") {
                this.validarUpdateStatus(this.acao_necessaria);
              }
            } else {
              this.showErrorMessageWithButton("Ops...", response.data.msg);
            }
          })
          .catch((error) => {
            console.log(error);
            this.showErrorMessageWithButton("Ops..", "Falha ao cadastrar notificação");
            this.isLoading = false;
          });

        console.log(this.acao_necessaria);
      } else {
        this.showErrorMessageWithButton("Ops...", "O campo conteúdo é obrigatório");
      }
    },

    cadastrarPendenciaEEmail() {
      if (this.corpo_pendencia_e_email != "") {
        this.isLoading = true;

        let data = {
          user_id: this.user.id,
          assunto: this.assunto_pendencia_e_email,
          corpo: this.corpo_pendencia_e_email,
        };

        console.log("Pendencia");
        console.log(data);

        axios
          .post(`/admin/pendencia/store_and_send`, data)
          .then((response) => {
            let btn = document.getElementById("fechar_pendencias_e_email");

            btn.click();

            this.isLoading = false;
            this.showSuccessMessage("Pendência cadastrada!");

            this.buscarPendencias();

            this.buscarUsuario();
          })
          .catch((error) => {
            console.log(error);
            this.showErrorMessageWithButtonAndRefresh("Ops..", "Email já cadastrado!");
            this.isLoading = false;
          });
      } else {
        this.showErrorMessageWithButton("Ops...", "O campo conteúdo é obrigatório");
      }
    },

    cadastrarPendencia() {
      if (this.conteudo_pendencia != "") {
        this.isLoading = true;

        let data = {
          user_id: this.user.id,
          conteudo: this.conteudo_pendencia,
        };

        console.log("Pendencia");
        console.log(data);

        axios
          .post(`/admin/pendencia/store`, data)
          .then((response) => {
            let btn = document.getElementById("fechar_pendencias");

            btn.click();

            this.isLoading = false;
            this.showSuccessMessage("Pendência cadastrada!");

            this.buscarPendencias();

            this.buscarUsuario();
          })
          .catch((error) => {
            console.log(error);
            this.showErrorMessageWithButtonAndRefresh("Ops..", "Email já cadastrado!");
            this.isLoading = false;
          });
      } else {
        this.showErrorMessageWithButton("Ops...", "O campo conteúdo é obrigatório");
      }
    },

    buscarNotificacoes() {
      let data = {
        user_id: this.user.id,
      };

      axios
        .post(`/admin/notificacoes/search`, data)
        .then((response) => {
          console.log("NOT");
          this.notificacoes = response.data.notificacoes;

          console.log(this.notificacoes);
        })
        .catch((error) => {
          console.log(error);
          this.showErrorMessageWithButton("Ops..", "Falha ao buscar notificações");
          this.isLoading = false;
        });
    },

    getUrlProposta(proposta) {
      return process.env.MIX_VUE_APP_URL + "/proposta/" + proposta.hash;
    },

    deletarProposta(proposta) {
      this.$swal
        .fire({
          title: "<h3 style='color:#616060'>Esta ação é irreversível, deseja continuar?</h3>",
          icon: "warning",
          padding: "1.5em",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, quero deletar!",
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;

            let data = {
              id: proposta.id,
            };

            axios
              .post(`/admin/proposta/delete`, data)
              .then((response) => {
                this.isLoading = false;
                this.showSuccessMessage("Proposta deletada!");
                this.buscarPropostas();
              })
              .catch((error) => {
                this.isLoading = false;
                this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
                console.log(error.response.data);
              });
          }
        });
    },

    convertTiny(value) {
      if (value == 0) {
        return "Não";
      } else {
        return "Sim";
      }
    },

    buscarHabilitacoes() {
      let data = {
        user_id: this.user.id,
        inicio: 0,
        tamanho: 10000,
        orderDesc: true,
      };

      console.log("habilitacoes");
      console.log(data);

      axios
        .post(`/admin/habilitacoes/search`, data)
        .then((response) => {
          this.habilitacoes = response.data.habilitacoes;

          console.log("HABILITAÇÕES ENCONTRADAS");
          console.log(this.habilitacoes);
        })
        .catch((error) => {
          console.log(error);
          this.showErrorMessageWithButton("Ops..", "Falha ao buscar habilitacoes");
          this.isLoading = false;
        });
    },

    buscarLotesArrematados() {
      let data = {
        user_id: this.user.id,
        inicio: 0,
        tamanho: 10000,
        orderDesc: true,
      };

      console.log("habilitacoes");
      console.log(data);

      axios
        .post(`/admin/lotes/search/arrematados`, data)
        .then((response) => {
          this.lotes_arrematados = response.data.lotes;

          console.log("ARREMATES ENCONTRADOS");
          console.log(this.lotes);
        })
        .catch((error) => {
          console.log(error);
          this.showErrorMessageWithButton("Ops..", "Falha ao buscar arremates");
          this.isLoading = false;
        });
    },

    buscarPropostas() {
      let data = {
        user_id: this.user.id,
        inicio: 0,
        tamanho: 10,
        filtro_proposta_status: "todas",
        desc: true,
      };

      console.log("propostas");
      console.log(data);

      axios
        .post(`/admin/propostas/search`, data)
        .then((response) => {
          this.propostas = response.data.propostas;
        })
        .catch((error) => {
          console.log(error);
          this.showErrorMessageWithButton("Ops..", "Falha ao buscar propostas");
          this.isLoading = false;
        });
    },

    buscarPendencias(checkLiberado, todas_resolvidas) {
      let data = {
        user_id: this.user.id,
      };

      console.log("Pendencia");
      console.log(data);

      axios
        .post(`/admin/pendencias/search`, data)
        .then((response) => {
          this.pendencias = response.data.pendencias;

          //OLD - NÃO VERIFICA QTD PENDENCIAS
          /*
                    if (checkLiberado && this.pendencias.length == 0) {
                        if (todas_resolvidas) {
                            this.showLotesBtnsOptionsPendencia();
                        } else {
                            let html = "Deseja notificar o cliente?";

                            this.$swal
                                .fire({
                                    title: "Confirmação",
                                    html: html,
                                    icon: "info",
                                    showCancelButton: true,
                                    cancelButtonText: 'Não',
                                    confirmButtonColor: "#3085d6",
                                    cancelButtonColor: "#d33",
                                    confirmButtonText: "Sim!"
                                })
                                .then(result => {
                                    if (result.value) {
                                        this.resolver(pendencia);
                                    }
                                });
                        }
                    }
                    */
        })
        .catch((error) => {
          console.log(error);
          this.showErrorMessageWithButton("Ops..", "Falha ao buscar pendências");
          this.isLoading = false;
        });
    },

    buscarDocumentosEnviadosUsuario() {
      let data = {
        user_id: this.user.id,
      };

      axios
        .post(`/admin/document/search-by-user`, data)
        .then((response) => {
          let docs = response.data.documents;
          let todos_aprovados = true;
          let possui_aguardando = false;

          this.my_user_documents = docs;

          for (let i = 0; i < docs.length; i++) {
            if (docs[i].verificado == 0) {
              possui_aguardando = true;
            } else if (docs[i].verificado == 2 || docs[i].expirado == 1) {
              todos_aprovados = false;
            }
          }

          if (!possui_aguardando && !todos_aprovados) {
            //EXIBIR MODAL COM PENDENTES/VENCIDOS
            this.gerarEmail();
          } else if (todos_aprovados && !possui_aguardando) {
            //EXIBIR MODAL PARA LIBERAR O CADASTRO
            this.showLotesBtnsOptionsPendencia();
          }
        })
        .catch((error) => {
          console.log(error);
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
        });
    },

    selecionarDocumento(document) {
      this.documento_selecionado = document;

      let arr = this.documento_selecionado.arquivo.split(".");
      this.file_type = arr[arr.length - 1];

      console.log("File = " + this.file_type);
      console.log(arr);
    },

    convertStatus(status) {
      if (status == 1) {
        return "Aprovado";
      } else if (status == 2) {
        return "Rejeitado";
      } else {
        return "Aguardando";
      }
    },

    getStyleHabilitacao(status) {
      let style = "cursor:pointer;";

      if (status == "pendente") {
        return style + "background-color: #fcfdcd";
      } else if (status == "liberado") {
        return style + "background-color: #d6fbe4";
      } else if (status == "bloqueado") {
        return style + "background-color: #ffdbdb";
      } else {
        return style;
      }
    },

    converterValidade(documento) {
      /*
            if (documento.expirado == 1) {
                return "Expirado";
            } else if (documento.expira == 0 || !documento.expira) {
                return " - "
            } else {
                return this.formatDate(documento.expira_em);
            }*/
      let data_validade = this.formatDateNotTime(documento.expira_em);

      if (data_validade == "Invalid date") {
        data_validade = "-";
      }

      return data_validade;
    },

    formatDateNotTime(date) {
      return moment(date).format("DD/MM/YYYY");
    },

    getStyleValidate(documento) {
      /*
            if (documento.expirado == 1) {
                return "background-color: red";
            } else if (documento.expira == 0) {
                return "background-color: green";
            } else {
                let data = this.formatDate(documento.expira_em);

                if (data != "Invalid date") {
                    let vencido = new Date() >= new Date(documento.expira_em);

                    if (vencido) {
                        return "background-color: orange";
                    } else {
                        return "background-color: green";
                    }
                }
            }*/

      let vencido = new Date() >= new Date(documento.expira_em);

      let style = "";

      if (vencido) {
        return style + "background-color: orange";
      } else {
        return style + "background-color: green";
      }
    },

    confirmarResolver(pendencia) {
      let html =
        "Deseja <b style='font-size:20px;color: green'>resolver </b> esta pendência?<br/> <b style='font-size:13px'>" + pendencia.conteudo + "</b>";

      this.$swal
        .fire({
          title: "Confirmação",
          html: html,
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim!",
        })
        .then((result) => {
          if (result.value) {
            this.resolver(pendencia);
          }
        });
    },

    showLotesBtnsOptionsPendencia() {
      this.acao_necessaria = "";

      this.$swal
        .fire({
          icon: "success",
          html: "O que deseja fazer?",
          title: "Cadastro sem pendências!",
          showCancelButton: true,
          showDenyButton: true,
          confirmButtonText: "Liberar e notificar",
          cancelButtonText: "Fechar",
          denyButtonText: "Liberar sem notificar",
        })
        .then((result) => {
          /* Read more about isConfirmed, isDenied below */
          console.log(result);
          if (result.isConfirmed) {
            this.acao_necessaria = "liberar";

            let btn = document.getElementById("notificacao_btn");
            btn.click();
          } else if (result.isDenied && result.isDismissed == false) {
            this.validarUpdateStatus("liberar");
          } else if (result.isDismissed && result.dismiss == "cancel") {
            //window.location.href = "/admin/leilao/" + leilao_id + "/lotes/cadastrar_lote";
            //CLIQUE FORA
          } else if (result.isDismissed && result.dismiss == "backdrop") {
            //window.location.href = "/admin/leilao/" + leilao_id + "/lotes/cadastrar_lote";
          }
        });
    },

    confirmarDelete(value, tipo) {
      let html = "Esta ação é irreversível. Deseja continuar? ";

      this.$swal
        .fire({
          title: "Atenção",
          html: html,
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim!",
        })
        .then((result) => {
          if (result.value) {
            if (tipo == "pendencia") {
              this.deletar(value);
            } else if (tipo == "documento") {
              this.deletarDocumento(value);
            } else {
              this.deletarNotificacao(value);
            }
          }
        });
    },

    validarUpdateStatus(acao, notificar) {
      console.log("APROVANDO");

      if (acao == "liberar") {
        this.$swal
          .fire({
            title: "Confirmação",
            html: "Existe pendências não resolvidas. Deseja marcá-las como resolvidas?",
            icon: "info",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sim, liberar e resolver pendências",
            cancelButtonText: "Não, apenas liberar",
          })
          .then((result) => {
            if (result.isConfirmed) {
              this.updateStatus(acao, notificar, true);
            } else if (result.isDismissed && result.dismiss == "cancel") {
              this.updateStatus(acao, notificar, false);
            }
          });
      } else {
        this.updateStatus(acao, notificar, false);
      }
    },

    async updateStatus(acao, notificar, resolver_pendencias) {
      this.isLoading = true;

      let msg = "";
      let status = "";

      if (acao == "bloquear") {
        msg = "Cadastro bloqueado";
        status = "bloqueado";
      } else if (acao == "liberar") {
        msg = "Cadastro liberado";
        status = "liberado";
      }

      let data = {
        user_id: this.user.id,
        status: status,
        notificar: notificar,
      };

      console.log("ENVIANDO ATUALIZAÇÃO DE STATUS");
      console.log(data);

      axios
        .post(`/admin/user/update_status`, data)
        .then(async (response) => {
          this.isLoading = false;

          if (resolver_pendencias) {
            try {
              await this.resolverTodasAsPendencias();
              // continua após resolver
              console.log("Pendências resolvidas. Continuando...");

              this.buscarPendencias();
            } catch (error) {
              // já foi tratado no método anterior, mas você pode adicionar mais lógica aqui se quiser
              console.warn("Erro ao resolver pendências");
            }
          }

          console.log(acao);
          console.log(response.data);

          if (response.data.success) {
            if (acao == "liberar" && response.data.habilitacoes_pendentes) {
              if (response.data.habilitacoes_pendentes == 1) {
                msg = msg + "<br/>Este usuário possui mais <br/><b>" + response.data.habilitacoes_pendentes + " habilitação pendente.</b>";
              } else if (response.data.habilitacoes_pendentes > 1) {
                msg = msg + "<br/>Este usuário possui mais <br/><b>" + response.data.habilitacoes_pendentes + " habilitações pendentes.</b>";

                this.$swal
                  .fire({
                    icon: "success",
                    title: "Sucesso",
                    padding: "1.5em",
                    html: msg,
                  })
                  .then(function () {});
              } else {
                this.showSuccessMessage(msg);
              }
            }

            this.buscarUsuario();
          } else {
            this.showErrorMessageWithButton("Ops...", response.data.msg);
          }
        })
        .catch((error) => {
          console.log(error);
          this.showErrorMessageWithButtonAndRefresh("Ops..", "Email já cadastrado!");
          this.isLoading = false;
        });
    },

    async resolverTodasAsPendencias(callback) {
      let data = {
        user_id: this.user.id,
      };

      try {
        await axios.post(`/admin/pendencia/resolver/todas`, data);
        this.isLoading = false;
        return true;
      } catch (error) {
        console.error(error);
        this.showErrorMessageWithButtonAndRefresh("Ops..", "Falha ao resolver todas as pendências!");
        this.isLoading = false;
        throw error; // importante para que o método que chamou saiba que falhou
      }
    },

    buscarUsuario(callback) {
      let data = {
        id: this.user_profile.user_id,
      };

      axios
        .post(`/admin/user/find`, data)
        .then((response) => {
          this.user = response.data.user;

          if (callback) {
            callback();
          }
        })
        .catch((error) => {
          console.log(error);
          this.showErrorMessageWithButton("Ops..", "Falha ao localizar usuário");
          this.isLoading = false;
        });
    },

    buscarUserProfile(cidades, cidades_pj) {
      this.my_cidades = cidades;
      this.my_cidades_pj = cidades_pj;

      let data = {
        id: this.user_profile.id,
      };

      axios
        .post(`/admin/user_profile/find`, data)
        .then((response) => {
          this.user_profile = response.data.user_profile;

          let data = {
            id: this.user.id,
          };

          axios
            .post(`/admin/user/find`, data)
            .then((response) => {
              this.user = response.data.user;
            })
            .catch((error) => {
              console.log(error);
              this.showErrorMessageWithButton("Ops..", "Falha ao localizar perfil do usuário");
              this.isLoading = false;
            });
        })
        .catch((error) => {
          console.log(error);
          this.showErrorMessageWithButton("Ops..", "Falha ao localizar perfil do usuário");
          this.isLoading = false;
        });
    },

    resolver(pendencia) {
      this.isLoading = true;

      let data = {
        id: pendencia.id,
        user_id: this.user.id,
      };

      axios
        .post(`/admin/pendencia/resolver`, data)
        .then((response) => {
          this.isLoading = false;

          this.showSuccessMessage("Pendência resolvida!");
          this.buscarPendencias(true, true);
        })
        .catch((error) => {
          console.log(error);
          this.showErrorMessageWithButtonAndRefresh("Ops..", "Email já cadastrado!");
          this.isLoading = false;
        });
    },

    deletar(pendencia) {
      this.isLoading = true;

      let data = {
        id: pendencia.id,
        user_id: this.user.id,
      };

      console.log("DELETANDO");
      console.log(data);

      axios
        .post(`/admin/pendencia/delete`, data)
        .then((response) => {
          this.isLoading = false;

          this.showSuccessMessage("Pendência deletada!");
          this.buscarPendencias(true, true);
        })
        .catch((error) => {
          console.log(error);
          this.showErrorMessageWithButtonAndRefresh("Ops..", "Email já cadastrado!");
          this.isLoading = false;
        });
    },

    deletarNotificacao(notificacao) {
      this.isLoading = true;

      let data = {
        id: notificacao.id,
        user_id: this.user.id,
      };

      console.log("DELETANDO");
      console.log(data);

      axios
        .post(`/admin/notificacao/delete`, data)
        .then((response) => {
          this.isLoading = false;

          this.showSuccessMessage("Notificação deletada!");
          this.buscarNotificacoes();
        })
        .catch((error) => {
          console.log(error);
          this.showErrorMessageWithButtonAndRefresh("Ops..", "Email já cadastrado!");
          this.isLoading = false;
        });
    },

    getOnlyDocumentPath(document) {
      console.log("Doc");
      console.log(document);

      if (document) {
        if (document.path.includes("rochaleiloes3")) {
          return document.path + "/" + document.arquivo;
        } else if (document.path.includes("rochaleiloes2")) {
          return document.path + "/" + document.arquivo;
        } else if (document.path.includes("rochaleiloes") || document.arquivo.includes("banner_")) {
          return document.path + "/" + document.arquivo;
        } else {
          return document.path + "/" + document.arquivo;
        }
      }
    },

    deletarDocumento(documento) {
      this.isLoading = true;

      let data = {
        id: documento.id,
      };

      console.log("DELETANDO DOC");
      console.log(data);

      axios
        .post(`/admin/document/delete`, data)
        .then((response) => {
          this.isLoading = false;

          if (response.data.success) {
            this.showSuccessMessage("Documento deletado!");

            let data = {
              path: this.getOnlyDocumentPath(documento),
            };

            console.log("DELETANDO S3");
            console.log(data);

            axios
              .post(process.env.MIX_VUE_APP_UPLOAD_URL + `/s3/delete-file`, data)
              .then((response) => {})
              .catch((error) => {
                console.log(error);
                this.isLoading = false;
                this.showErrorMessageWithButton("Ops..", error);
              });

            this.buscarDocumentosEnviadosUsuario();
          } else {
            this.showErrorMessageWithButton("Ops...", response.data.msg);

            this.buscarDocumentosEnviadosUsuario();
          }
        })
        .catch((error) => {
          console.log(error);
          this.showErrorMessageWithButtonAndRefresh("Ops..", "Email já cadastrado!");
          this.isLoading = false;
        });
    },

    getDocumentPath(document) {
      if (document && document.path) {
        if (document.path.includes("rochaleiloes3")) {
          return process.env.MIX_VUE_APP_S3_BASE3_URL + document.path + "/" + document.arquivo;
        } else if (document.path.includes("rochaleiloes2")) {
          return process.env.MIX_VUE_APP_S3_BASE2_URL + document.path + "/" + document.arquivo;
        } else if (document.path.includes("rochaleiloes") || document.arquivo.includes("banner_")) {
          return process.env.MIX_VUE_APP_S3_BASE_URL + document.path + "/" + document.arquivo;
        } else {
          return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + document.path + "/" + document.arquivo;
        }
      }
    },

    async sendFileS3() {
      if (this.upload_files != "" && this.documento_selecionado != "") {
        if (this.upload_files) {
          this.isLoading = true;

          return new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append("id", "1");
            formData.append("path", "rochaleiloes2/usuarios/" + this.user.id + "/");
            formData.append("file", this.upload_files);

            axios
              .post(process.env.MIX_VUE_APP_UPLOAD_URL + `/s3/upload`, formData)
              .then((response) => {
                console.log("ENVIANDO PARA O BANCO\n");

                this.uploadFD(response.data.key);
              })
              .catch((error) => {
                console.log(error);

                this.isLoading = false;
                this.showErrorMessageWithButton("Ops..", error.response.data.error);
                console.log(error);
                reject();
              });
          });
        } else {
          this.showErrorMessageWithButton("Ops...", "Envio um arquivo válido!");
          this.cep_valido = false;
        }
      } else {
        this.showErrorMessageWithButton("Ops...", "Preencha os dados corretamente");
      }
    },

    async uploadFD(file) {
      this.isLoading = true;

      let fileName = file.split("/");

      let fd = new FormData();
      fd.append("cpf_formatado", this.user_profile.cpf.replace(/[^Z0-9]/g, ""));
      fd.append("path", "rochaleiloes2/usuarios/" + this.user.id);
      fd.append("file", fileName[fileName.length - 1]);
      fd.append("obrigatorio", this.documento_selecionado.obrigatorio);
      fd.append("tipodoc", this.documento_selecionado.tipodoc);
      fd.append("user_id", this.user.id);

      console.log("ATUALIZANDO");
      console.log(fd);

      axios
        .post(`/admin/document/upload`, fd)
        .then((response) => {
          this.showSuccessMessage("Documento enviado!");

          this.isLoading = false;

          let btn = document.getElementById("fechar_documentos");

          btn.click();

          this.buscarDocumentosEnviadosUsuario();
          this.buscarUsuario();
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;

          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    salvar() {
      if (this.verificado == 1 || this.verificado == 2) {
        this.isLoading = true;

        let data = {
          id: this.document.id,
          verificado: this.verificado,
          reason: this.reason,
        };

        console.log("Buscando");
        console.log(data);

        axios
          .post(`/admin/user/document/verify`, data)
          .then((response) => {
            this.showSuccessMessage("Documento verificado");

            this.redirect();
          })
          .catch((error) => {
            this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
            console.log(error.response.data);
          });
      } else {
        this.showErrorMessageWithButton("Ops...", "Escolha uma opção.");
      }
    },

    getStyle(status) {
      if (status == 1) {
        return "color: #007d41";
      } else if (status == 2) {
        return "color: red";
      } else {
        ("");
      }
    },
    redirect() {
      window.location.href = "/admin" + this.url_voltar;
    },

    getFileType() {
      let arr = this.document.arquivo.split(".");
      this.file_type = arr[arr.length - 1];

      console.log("File = " + this.file_type);
      console.log(arr);
    },

    formatDate(date) {
      let result = moment(date).format("DD/MM/YYYY");

      if (result == "Invalid date") {
        result = moment(date, "yyyy-MM-DD").format("DD/MM/yyyy");
      }

      return result;
    },

    formatDateTime(date) {
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },
  },
};
</script>

<style scoped>
.btn-danger:hover {
  color: #fff;
  background-color: #d2322d !important;
  border-color: #ac2925 !important;
}

.green {
  background-color: rgb(214, 251, 228);
}

strong {
  margin-right: 3px;
}

p {
  margin-top: -10px;
}

.check-card {
  width: 100%;
  height: 250px;
  text-align: center;
  cursor: pointer;
}

img {
  max-width: 100%;
  max-height: 100%;
}

textarea:focus {
  border-color: gray;
}

.rejeitado {
  border-style: solid;
  border-width: thin;
  border-color: red;
}

.aprovado {
  border-style: solid;
  border-width: thin;
  border-color: green;
}

.modal-content {
  width: 1000px;
  margin-left: -150px;
}

@media screen and (max-width: 1200px) {
  .modal-content {
    width: 800px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 800px) {
  .modal-content {
    width: 600px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 600px) {
  .modal-content {
    width: 100%;
    margin-left: 0;
    margin-bottom: 100px;
  }
}

.iconDiv {
  height: 36px;
  width: 36px;
  margin-top: 20px;
  margin-bottom: 20px;
  margin-left: 4px;
  padding: 4px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  cursor: pointer;
  transition: width 300ms ease-in-out 0s, background-color 300ms linear 200ms;
}

.iconSVG {
  margin-left: 2px;
  height: 20px;
  aspect-ratio: 1 / 1;
}

.iconDiv:hover,
.iconDiv:focus-visible {
  width: 142px;
  background-color: #301904;
  transition: width 300ms ease-in-out 0s, background-color 100ms linear 0s;
}

.iconDiv:focus-visible {
  outline: 1px solid var(--color-mid);
  outline-offset: 4px;
}

.iconDiv:active {
  opacity: 0.9;
}

.iconDiv::after {
  content: attr(tooltip);
  margin-left: 12px;
  animation: fadeIn 600ms linear forwards;
}

.spacer {
  flex-grow: 1;
}

.divider {
  height: 36px;
  width: 1px;
  margin: 24px 18px;
  background-color: var(--color-dark);
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
</style>
